// ! This file was auto-generated by @rtk-query/codegen-openapi. Do not override this file.

import { api } from "~/redux/api/k2/codegenApi";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        readinessCheck: build.query<ReadinessCheckApiResponse, ReadinessCheckApiArg>({
            query: () => ({ url: `/health/readiness` }),
        }),
        livenessCheck: build.query<LivenessCheckApiResponse, LivenessCheckApiArg>({
            query: () => ({ url: `/health/liveness` }),
        }),
        getWorkflowFieldUsages: build.query<GetWorkflowFieldUsagesApiResponse, GetWorkflowFieldUsagesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/field-usages`,
                params: {
                    page: queryArg.page,
                    field_id: queryArg.fieldId,
                    field_lookup_table_id: queryArg.fieldLookupTableId,
                    is_required: queryArg.isRequired,
                    search: queryArg.search,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        requestWorkflowDocumentUpload: build.mutation<RequestWorkflowDocumentUploadApiResponse, RequestWorkflowDocumentUploadApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/upload-request`,
                method: "POST",
                body: queryArg.documentUploadUrlRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        workflowUploadComplete: build.mutation<WorkflowUploadCompleteApiResponse, WorkflowUploadCompleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}/upload-complete`,
                method: "POST",
                body: queryArg.documentUploadCompleteRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflowDocumentDownloadUrl: build.query<GetWorkflowDocumentDownloadUrlApiResponse, GetWorkflowDocumentDownloadUrlApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}/download-request`,
                params: {
                    document_version: queryArg.documentVersion,
                    format: queryArg.format,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteWorkflowDocument: build.mutation<DeleteWorkflowDocumentApiResponse, DeleteWorkflowDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        replaceWorkflowDocumentPlaceholderMappings: build.mutation<ReplaceWorkflowDocumentPlaceholderMappingsApiResponse, ReplaceWorkflowDocumentPlaceholderMappingsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/documents/${queryArg.documentId}/placeholder-mappings`,
                method: "PUT",
                body: queryArg.placeholderMappingsRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createWorkflow: build.mutation<CreateWorkflowApiResponse, CreateWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows`,
                method: "POST",
                body: queryArg.createWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflows: build.query<ListWorkflowsApiResponse, ListWorkflowsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows`,
                params: {
                    page: queryArg.page,
                    include: queryArg.include,
                    published: queryArg.published,
                    search: queryArg.search,
                    created_by: queryArg.createdBy,
                    created_at_gte: queryArg.createdAtGte,
                    created_at_lte: queryArg.createdAtLte,
                    updated_at_gte: queryArg.updatedAtGte,
                    updated_at_lte: queryArg.updatedAtLte,
                    sort: queryArg.sort,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWorkflow: build.query<GetWorkflowApiResponse, GetWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}`,
                params: { version: queryArg.version, include: queryArg.include },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkflow: build.mutation<UpdateWorkflowApiResponse, UpdateWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}`,
                method: "PUT",
                body: queryArg.updateWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteWorkflow: build.mutation<DeleteWorkflowApiResponse, DeleteWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        publishWorkflow: build.mutation<PublishWorkflowApiResponse, PublishWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/publish`,
                method: "PATCH",
                body: queryArg.publishWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        unpublishWorkflow: build.mutation<UnpublishWorkflowApiResponse, UnpublishWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/unpublish`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cloneWorkflow: build.mutation<CloneWorkflowApiResponse, CloneWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/clone`,
                method: "POST",
                body: queryArg.cloneWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateWorkflowAcl: build.mutation<UpdateWorkflowAclApiResponse, UpdateWorkflowAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/acl`,
                method: "PATCH",
                body: queryArg.updateWorkflowAclRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        validateWorkflow: build.mutation<ValidateWorkflowApiResponse, ValidateWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/validate`,
                method: "POST",
                body: queryArg.validateWorkflowRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        evaluateWorkflowFormVisibility: build.mutation<EvaluateWorkflowFormVisibilityApiResponse, EvaluateWorkflowFormVisibilityApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/form-visibility-evaluation`,
                method: "POST",
                body: queryArg.workflowFormVisibilityEvaluationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowActivityLogs: build.query<ListWorkflowActivityLogsApiResponse, ListWorkflowActivityLogsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflows/${queryArg.workflowId}/activity-logs`,
                params: {
                    resource_type: queryArg.resourceType,
                    action: queryArg.action,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listWorkflowTemplates: build.query<ListWorkflowTemplatesApiResponse, ListWorkflowTemplatesApiArg>({
            query: () => ({ url: `/api/v1/workflow-templates` }),
        }),
        getWorkflowTemplate: build.query<GetWorkflowTemplateApiResponse, GetWorkflowTemplateApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/workflow-templates/${queryArg.templateId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listStages: build.query<ListStagesApiResponse, ListStagesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        transitionToNextStage: build.mutation<TransitionToNextStageApiResponse, TransitionToNextStageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/next`,
                method: "POST",
                body: queryArg.stageTransitionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        transitionToStage: build.mutation<TransitionToStageApiResponse, TransitionToStageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/${queryArg.targetStageId}`,
                method: "POST",
                body: queryArg.stageTransitionRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateStageAcl: build.mutation<UpdateStageAclApiResponse, UpdateStageAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/${queryArg.stageId}/acl`,
                method: "PATCH",
                body: queryArg.updateStageAclRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteStageAcl: build.mutation<DeleteStageAclApiResponse, DeleteStageAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/stages/${queryArg.stageId}/acl`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTasks: build.query<ListTasksApiResponse, ListTasksApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks`,
                params: {
                    stage_id: queryArg.stageId,
                    status: queryArg.status,
                    assignee: queryArg.assignee,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createAdHocTask: build.mutation<CreateAdHocTaskApiResponse, CreateAdHocTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks`,
                method: "POST",
                body: queryArg.adHocTaskCreateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTask: build.query<GetTaskApiResponse, GetTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateAdHocTask: build.mutation<UpdateAdHocTaskApiResponse, UpdateAdHocTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}`,
                method: "PATCH",
                body: queryArg.adHocTaskUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteAdHocTask: build.mutation<DeleteAdHocTaskApiResponse, DeleteAdHocTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        completeTask: build.mutation<CompleteTaskApiResponse, CompleteTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/complete`,
                method: "POST",
                body: queryArg.taskCompleteRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        assignTask: build.mutation<AssignTaskApiResponse, AssignTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/assign`,
                method: "PATCH",
                body: queryArg.taskAssignRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        claimTask: build.mutation<ClaimTaskApiResponse, ClaimTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/claim`,
                method: "POST",
                body: queryArg.taskClaimRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resetTask: build.mutation<ResetTaskApiResponse, ResetTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/reset`,
                method: "POST",
                body: queryArg.taskResetRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        retractJudgment: build.mutation<RetractJudgmentApiResponse, RetractJudgmentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/retract`,
                method: "POST",
                body: queryArg.taskResetRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTaskAssociation: build.mutation<UpdateTaskAssociationApiResponse, UpdateTaskAssociationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/associations`,
                method: "PATCH",
                body: queryArg.taskAssociationUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTaskAcl: build.mutation<UpdateTaskAclApiResponse, UpdateTaskAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/acl`,
                method: "PATCH",
                body: queryArg.updateTaskAclRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTaskAcl: build.mutation<DeleteTaskAclApiResponse, DeleteTaskAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/acl`,
                method: "DELETE",
                params: { version: queryArg.version },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        remindTask: build.mutation<RemindTaskApiResponse, RemindTaskApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/tasks/${queryArg.taskId}/remind`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateField: build.mutation<UpdateFieldApiResponse, UpdateFieldApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/fields/${queryArg.fieldId}`,
                method: "PATCH",
                body: queryArg.fieldUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateFieldsBatch: build.mutation<UpdateFieldsBatchApiResponse, UpdateFieldsBatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/fields`,
                method: "PATCH",
                body: queryArg.fieldBatchUpdateRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createComment: build.mutation<CreateCommentApiResponse, CreateCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments`,
                method: "POST",
                body: queryArg.createCommentRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listComments: build.query<ListCommentsApiResponse, ListCommentsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments`,
                params: {
                    task_id: queryArg.taskId,
                    filter: queryArg.filter,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listThreads: build.query<ListThreadsApiResponse, ListThreadsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/threads`,
                params: {
                    task_id: queryArg.taskId,
                    filter: queryArg.filter,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getComment: build.query<GetCommentApiResponse, GetCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateComment: build.mutation<UpdateCommentApiResponse, UpdateCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}`,
                method: "PATCH",
                body: queryArg.updateCommentRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteComment: build.mutation<DeleteCommentApiResponse, DeleteCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resolveComment: build.mutation<ResolveCommentApiResponse, ResolveCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}/resolve`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        unresolveComment: build.mutation<UnresolveCommentApiResponse, UnresolveCommentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/comments/${queryArg.commentId}/unresolve`,
                method: "PATCH",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        forceUnlockTicketDocument: build.mutation<ForceUnlockTicketDocumentApiResponse, ForceUnlockTicketDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/force-unlock`,
                method: "POST",
                body: queryArg.documentForceUnlockRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        versionUpTicketDocument: build.mutation<VersionUpTicketDocumentApiResponse, VersionUpTicketDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/version-up`,
                method: "POST",
                body: queryArg.documentVersionUpRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        patchDocument: build.mutation<PatchDocumentApiResponse, PatchDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}`,
                method: "PATCH",
                body: queryArg.documentPatchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTicketDocument: build.mutation<DeleteTicketDocumentApiResponse, DeleteTicketDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}`,
                method: "DELETE",
                params: {
                    version: queryArg.version,
                    document_lock_version: queryArg.documentLockVersion,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        recordSignatures: build.mutation<RecordSignaturesApiResponse, RecordSignaturesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/sign-tasks/${queryArg.taskId}/record-signatures`,
                method: "POST",
                body: queryArg.recordSignaturesRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        recordSignaturesBatch: build.mutation<RecordSignaturesBatchApiResponse, RecordSignaturesBatchApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/sign-tasks/${queryArg.taskId}/record-signatures-batch`,
                method: "POST",
                body: queryArg.recordSignaturesBatchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getSigningConfiguration: build.query<GetSigningConfigurationApiResponse, GetSigningConfigurationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/signing-participants/${queryArg.taskId}`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        replaceSigningConfiguration: build.mutation<ReplaceSigningConfigurationApiResponse, ReplaceSigningConfigurationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/signing-participants/${queryArg.taskId}`,
                method: "PUT",
                body: queryArg.signingConfigurationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createEsignPackage: build.mutation<CreateEsignPackageApiResponse, CreateEsignPackageApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/esign-packages`,
                method: "POST",
                body: queryArg.createEsignPackageRequest,
                params: { sync: queryArg.sync },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketActions: build.query<GetTicketActionsApiResponse, GetTicketActionsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/actions`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTickets: build.query<ListTicketsApiResponse, ListTicketsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets`,
                params: {
                    state: queryArg.state,
                    workflow_id: queryArg.workflowId,
                    contract_record_unique_id: queryArg.contractRecordUniqueId,
                    page: queryArg.page,
                    include: queryArg.include,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        createTicket: build.mutation<CreateTicketApiResponse, CreateTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets`,
                method: "POST",
                body: queryArg.createTicketRequest,
                params: { reference_id: queryArg.referenceId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        searchTickets: build.mutation<SearchTicketsApiResponse, SearchTicketsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/search`,
                method: "POST",
                body: queryArg.ticketSearchRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cloneTicket: build.mutation<CloneTicketApiResponse, CloneTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/clone`,
                method: "POST",
                body: queryArg.cloneTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicket: build.query<GetTicketApiResponse, GetTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}`,
                params: { include: queryArg.include },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        deleteTicket: build.mutation<DeleteTicketApiResponse, DeleteTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}`,
                method: "DELETE",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTicketMetadata: build.mutation<UpdateTicketMetadataApiResponse, UpdateTicketMetadataApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}`,
                method: "PATCH",
                body: queryArg.updateTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketState: build.query<GetTicketStateApiResponse, GetTicketStateApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/state`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        evaluateTicketFormVisibility: build.mutation<EvaluateTicketFormVisibilityApiResponse, EvaluateTicketFormVisibilityApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/form-visibility-evaluation`,
                method: "POST",
                body: queryArg.ticketFormVisibilityEvaluationRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        pauseTicket: build.mutation<PauseTicketApiResponse, PauseTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/pause`,
                method: "POST",
                body: queryArg.pauseTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resumeTicket: build.mutation<ResumeTicketApiResponse, ResumeTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/resume`,
                method: "POST",
                body: queryArg.resumeTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        cancelTicket: build.mutation<CancelTicketApiResponse, CancelTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/cancel`,
                method: "POST",
                body: queryArg.cancelTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        completeTicket: build.mutation<CompleteTicketApiResponse, CompleteTicketApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/complete`,
                method: "POST",
                body: queryArg.completeTicketRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resetStageTasks: build.mutation<ResetStageTasksApiResponse, ResetStageTasksApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/reset-tasks`,
                method: "POST",
                body: queryArg.resetStageTasksRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        updateTicketAcl: build.mutation<UpdateTicketAclApiResponse, UpdateTicketAclApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/acl`,
                method: "PATCH",
                body: queryArg.updateTicketAclRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        reassignTicketOwner: build.mutation<ReassignTicketOwnerApiResponse, ReassignTicketOwnerApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/owner`,
                method: "PATCH",
                body: queryArg.reassignTicketOwnerRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listTicketActivityLogs: build.query<ListTicketActivityLogsApiResponse, ListTicketActivityLogsApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/activity-logs`,
                params: {
                    resource_type: queryArg.resourceType,
                    action: queryArg.action,
                    page: queryArg.page,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        shareExternally: build.mutation<ShareExternallyApiResponse, ShareExternallyApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/share-externally`,
                method: "POST",
                body: queryArg.shareExternallyRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        shareInternally: build.mutation<ShareInternallyApiResponse, ShareInternallyApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/share-internally`,
                method: "POST",
                body: queryArg.shareInternallyRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        resolveRenewalWorkflow: build.query<ResolveRenewalWorkflowApiResponse, ResolveRenewalWorkflowApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/contract-actions/renewal-workflow`,
                params: { source_document_id: queryArg.sourceDocumentId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        bulkReassignTasks: build.mutation<BulkReassignTasksApiResponse, BulkReassignTasksApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/admin/tasks/bulk-reassign`,
                method: "POST",
                body: queryArg.bulkReassignRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        searchSuppliers: build.query<SearchSuppliersApiResponse, SearchSuppliersApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/suppliers`,
                params: { q: queryArg.q, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        listContractTypes: build.query<ListContractTypesApiResponse, ListContractTypesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/contract-types`,
                params: { page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getIntakeFormLink: build.query<GetIntakeFormLinkApiResponse, GetIntakeFormLinkApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/${queryArg.workflowId}/intake-form/link`,
                params: { reference_id: queryArg.referenceId },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getExpressionAstSchema: build.query<GetExpressionAstSchemaApiResponse, GetExpressionAstSchemaApiArg>({
            query: () => ({ url: `/api/v1/schemas/expression-ast` }),
        }),
        searchCompanies: build.query<SearchCompaniesApiResponse, SearchCompaniesApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/integrate-workflow/companies`,
                params: { q: queryArg.q, page: queryArg.page },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        requestDocumentUpload: build.mutation<RequestDocumentUploadApiResponse, RequestDocumentUploadApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/upload-request`,
                method: "POST",
                body: queryArg.ticketDocumentUploadUrlRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        uploadComplete: build.mutation<UploadCompleteApiResponse, UploadCompleteApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/upload-complete`,
                method: "POST",
                body: queryArg.documentUploadCompleteRequest,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDownloadUrl: build.query<GetDownloadUrlApiResponse, GetDownloadUrlApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/download-request`,
                params: {
                    document_version: queryArg.documentVersion,
                    format: queryArg.format,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getDocumentComparison: build.query<GetDocumentComparisonApiResponse, GetDocumentComparisonApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/comparisons`,
                params: {
                    newer_version: queryArg.newerVersion,
                    older_version: queryArg.olderVersion,
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getTicketVersion: build.query<GetTicketVersionApiResponse, GetTicketVersionApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/version`,
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        scribylLockDocument: build.mutation<ScribylLockDocumentApiResponse, ScribylLockDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/lock`,
                method: "POST",
                body: queryArg.scribylDocumentLockRequest,
                headers: {
                    "X-Document-Lock-Version": queryArg["X-Document-Lock-Version"],
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        scribylUnlockDocument: build.mutation<ScribylUnlockDocumentApiResponse, ScribylUnlockDocumentApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/tickets/${queryArg.ticketId}/documents/${queryArg.documentId}/unlock`,
                method: "POST",
                body: queryArg.scribylDocumentUnlockRequest,
                headers: {
                    "X-Document-Lock-Version": queryArg["X-Document-Lock-Version"],
                },
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
        getWssWorkflows: build.query<GetWssWorkflowsApiResponse, GetWssWorkflowsApiArg>({
            query: () => ({ url: `/api/v1/wss/workflows` }),
        }),
        updateWssContractNegotiation: build.mutation<UpdateWssContractNegotiationApiResponse, UpdateWssContractNegotiationApiArg>({
            query: (queryArg) => ({
                url: `/api/v1/wss/contract-negotiations/${queryArg.contractRecordUniqueId}/update`,
                method: "POST",
                rtkQueryOptions: (queryArg as any)?.rtkQueryOptions
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ReadinessCheckApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type ReadinessCheckApiArg = void;
export type LivenessCheckApiResponse = 
/** status 200 Successful Response */ HealthcheckReport;
export type LivenessCheckApiArg = void;
export type GetWorkflowFieldUsagesApiResponse = 
/** status 200 Successful Response */ FieldUsagesResponse;
export type GetWorkflowFieldUsagesApiArg = {
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
    /** UF field UUID to find in form-question usage */
    fieldId?: UuidStr | null;
    /** Field lookup table id to find in field_library[].field_lookup_table.field_lookup_table_id */
    fieldLookupTableId?: string | null;
    /** Filter field_id usage to required usage only */
    isRequired?: boolean | null;
    /** Free-text search over workflow name. Matches whole words and word prefixes; workflows matching any query term are returned. A multi-word query is ordered by relevance (ts_rank_cd) instead of recency; this endpoint has no `sort` parameter to override that. */
    search?: string | null;
};
export type RequestWorkflowDocumentUploadApiResponse = 
/** status 201 Successful Response */ DocumentUploadUrlResponse;
export type RequestWorkflowDocumentUploadApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    documentUploadUrlRequest: DocumentUploadUrlRequest;
};
export type WorkflowUploadCompleteApiResponse = 
/** status 200 Successful Response */ DocumentUploadCompleteResponse;
export type WorkflowUploadCompleteApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    documentId: string;
    documentUploadCompleteRequest: DocumentUploadCompleteRequest;
};
export type GetWorkflowDocumentDownloadUrlApiResponse = 
/** status 200 Successful Response */ DocumentDownloadUrlResponse;
export type GetWorkflowDocumentDownloadUrlApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    documentId: string;
    /** Specific version to retrieve. Omit for latest. */
    documentVersion?: number | null;
    /** Which format to download. ``original`` returns the uploaded file; ``sfdt`` returns the cached SFDT conversion. */
    format?: DocumentFormat;
};
export type DeleteWorkflowDocumentApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteWorkflowDocumentApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Unique template document identifier (UUID) */
    documentId: UuidPath;
    /** Current version for optimistic locking */
    version: number;
};
export type ReplaceWorkflowDocumentPlaceholderMappingsApiResponse = 
/** status 200 Successful Response */ PlaceholderMappingsResponse;
export type ReplaceWorkflowDocumentPlaceholderMappingsApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Unique template document identifier (UUID) */
    documentId: UuidPath;
    placeholderMappingsRequest: PlaceholderMappingsRequest;
};
export type CreateWorkflowApiResponse = 
/** status 201 Successful Response */ CreateWorkflowResponse;
export type CreateWorkflowApiArg = {
    createWorkflowRequest: CreateWorkflowRequest;
};
export type ListWorkflowsApiResponse = 
/** status 200 Successful Response */ ListWorkflowsResponse;
export type ListWorkflowsApiArg = {
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
    /** Data to include in response. By default, only metadata is returned for performance. */
    include?: WorkflowIncludeParam[];
    /** Filter by published status */
    published?: boolean | null;
    /** Free-text search over workflow name. Matches whole words and word prefixes; a workflow needs to match only some of the query's words, not all of them, to be returned (e.g. 'find me a standard NDA' matches a workflow named 'NDA Review'). tsquery operators are stripped. When set and `sort` is left on the `created_at` field (the default), multi-word queries are ordered by `ts_rank_cd` relevance instead of recency. Single-word queries keep the prior created_at ordering. Sorting by any other field is always honored as the primary order; relevance only breaks ties between results with an equal sort value in that case. */
    search?: string | null;
    /** Exact-match filter on the user who created the latest version. */
    createdBy?: string | null;
    /** Inclusive lower bound on the latest-version created_at (ISO 8601). */
    createdAtGte?: string | null;
    /** Inclusive upper bound on the latest-version created_at (ISO 8601). */
    createdAtLte?: string | null;
    /** Inclusive lower bound on the latest-version updated_at (ISO 8601). */
    updatedAtGte?: string | null;
    /** Inclusive upper bound on the latest-version updated_at (ISO 8601). */
    updatedAtLte?: string | null;
    /** Sort key. Leading '-' is descending. Default is most-recently-revised first. If left on the `created_at` field (either direction) while `search` is also set, relevance leads instead — see the `search` parameter. Sorting by any other field (e.g. `name`) always wins as the primary order, even while searching. */
    sort?: WorkflowSortParam;
};
export type GetWorkflowApiResponse = 
/** status 200 Successful Response */ GetWorkflowResponse;
export type GetWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Specific version to retrieve. Omit for latest. */
    version?: number | null;
    /** Data to include in the response. When omitted (empty list), every field — including ``workflow_definition`` and ``acl`` — is loaded. Pass specific tokens (e.g. ``?include=acl``) to load only those gated fields and skip the rest as a payload optimisation. */
    include?: WorkflowIncludeParam[];
};
export type UpdateWorkflowApiResponse = 
/** status 200 Successful Response */ UpdateWorkflowResponse;
export type UpdateWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    updateWorkflowRequest: UpdateWorkflowRequest;
};
export type DeleteWorkflowApiResponse = unknown;
export type DeleteWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
};
export type PublishWorkflowApiResponse = 
/** status 200 Successful Response */ PublishWorkflowResponse;
export type PublishWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    publishWorkflowRequest: PublishWorkflowRequest;
};
export type UnpublishWorkflowApiResponse = 
/** status 200 Successful Response */ GetWorkflowResponse;
export type UnpublishWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
};
export type CloneWorkflowApiResponse = 
/** status 201 Successful Response */ CreateWorkflowResponse;
export type CloneWorkflowApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    cloneWorkflowRequest: CloneWorkflowRequest;
};
export type UpdateWorkflowAclApiResponse = 
/** status 200 Successful Response */ UpdateWorkflowAclResponse;
export type UpdateWorkflowAclApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    updateWorkflowAclRequest: UpdateWorkflowAclRequest;
};
export type ValidateWorkflowApiResponse = 
/** status 200 Successful Response */ ValidateWorkflowResponse;
export type ValidateWorkflowApiArg = {
    validateWorkflowRequest: ValidateWorkflowRequest;
};
export type EvaluateWorkflowFormVisibilityApiResponse = 
/** status 200 Successful Response */ FormVisibilityEvaluationResponse;
export type EvaluateWorkflowFormVisibilityApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    workflowFormVisibilityEvaluationRequest: WorkflowFormVisibilityEvaluationRequest;
};
export type ListWorkflowActivityLogsApiResponse = 
/** status 200 Successful Response */ ListActivityLogsResponse;
export type ListWorkflowActivityLogsApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** Filter by resource type */
    resourceType?: string | null;
    /** Filter by action */
    action?: string | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type ListWorkflowTemplatesApiResponse = 
/** status 200 Successful Response */ ListWorkflowTemplatesResponse;
export type ListWorkflowTemplatesApiArg = void;
export type GetWorkflowTemplateApiResponse = 
/** status 200 Successful Response */ ModelResponseWorkflowTemplateResponseData;
export type GetWorkflowTemplateApiArg = {
    /** Template identifier (e.g. 'scratch') */
    templateId: string;
};
export type ListStagesApiResponse = 
/** status 200 Successful Response */ ListStagesResponse;
export type ListStagesApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
};
export type TransitionToNextStageApiResponse = 
/** status 200 Successful Response */ StageTransitionResponse;
export type TransitionToNextStageApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    stageTransitionRequest: StageTransitionRequest;
};
export type TransitionToStageApiResponse = 
/** status 200 Successful Response */ StageTransitionResponse;
export type TransitionToStageApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the target stage to transition to */
    targetStageId: string;
    stageTransitionRequest: StageTransitionRequest;
};
export type UpdateStageAclApiResponse = 
/** status 200 Successful Response */ UpdateStageAclResponse;
export type UpdateStageAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the stage whose ACL is being updated */
    stageId: string;
    updateStageAclRequest: UpdateStageAclRequest;
};
export type DeleteStageAclApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteStageAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the stage whose ACL override is being removed */
    stageId: string;
    /** Current version for optimistic locking */
    version: number;
};
export type ListTasksApiResponse = 
/** status 200 Successful Response */ ListTasksResponse;
export type ListTasksApiArg = {
    ticketId: string;
    /** Filter by stage ID. Use '*' for all stages. */
    stageId?: string | null;
    /** Filter by task status */
    status?: TaskStatus | null;
    /** Filter by assigned user */
    assignee?: string | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type CreateAdHocTaskApiResponse = 
/** status 201 Successful Response */ GetTaskResponse;
export type CreateAdHocTaskApiArg = {
    ticketId: string;
    adHocTaskCreateRequest: AdHocTaskCreateRequest;
};
export type GetTaskApiResponse = 
/** status 200 Successful Response */ GetTaskResponse;
export type GetTaskApiArg = {
    ticketId: string;
    /** Unique task identifier within the ticket */
    taskId: string;
};
export type UpdateAdHocTaskApiResponse = 
/** status 200 Successful Response */ GetTaskResponse;
export type UpdateAdHocTaskApiArg = {
    ticketId: string;
    taskId: string;
    adHocTaskUpdateRequest: AdHocTaskUpdateRequest;
};
export type DeleteAdHocTaskApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteAdHocTaskApiArg = {
    ticketId: string;
    taskId: string;
    /** Current version for optimistic locking */
    version: number;
};
export type CompleteTaskApiResponse = 
/** status 200 Successful Response */ TaskCompleteResponse;
export type CompleteTaskApiArg = {
    ticketId: string;
    taskId: string;
    taskCompleteRequest: TaskCompleteRequest;
};
export type AssignTaskApiResponse = 
/** status 200 Successful Response */ GetTaskResponse;
export type AssignTaskApiArg = {
    ticketId: string;
    taskId: string;
    taskAssignRequest: TaskAssignRequest;
};
export type ClaimTaskApiResponse = 
/** status 200 Successful Response */ GetTaskResponse;
export type ClaimTaskApiArg = {
    ticketId: string;
    taskId: string;
    taskClaimRequest: TaskClaimRequest;
};
export type ResetTaskApiResponse = 
/** status 200 Successful Response */ GetTaskResponse;
export type ResetTaskApiArg = {
    ticketId: string;
    taskId: string;
    taskResetRequest: TaskResetRequest;
};
export type RetractJudgmentApiResponse = 
/** status 200 Successful Response */ GetTaskResponse;
export type RetractJudgmentApiArg = {
    ticketId: string;
    taskId: string;
    taskResetRequest: TaskResetRequest;
};
export type UpdateTaskAssociationApiResponse = 
/** status 200 Successful Response */ GetTaskResponse;
export type UpdateTaskAssociationApiArg = {
    ticketId: string;
    taskId: string;
    taskAssociationUpdateRequest: TaskAssociationUpdateRequest;
};
export type UpdateTaskAclApiResponse = 
/** status 200 Successful Response */ UpdateTaskAclResponse;
export type UpdateTaskAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the task whose ACL is being updated */
    taskId: string;
    updateTaskAclRequest: UpdateTaskAclRequest;
};
export type DeleteTaskAclApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteTaskAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** ID of the task whose ACL override is being removed */
    taskId: string;
    /** Current version for optimistic locking */
    version: number;
};
export type RemindTaskApiResponse = 
/** status 200 Successful Response */ EmptyResponse;
export type RemindTaskApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unique task identifier (UUID) */
    taskId: UuidPath;
};
export type UpdateFieldApiResponse = 
/** status 200 Successful Response */ FieldUpdateResponse;
export type UpdateFieldApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Unified Fields field ID (UUID); matches keys in ticket field_values. */
    fieldId: UuidPath;
    fieldUpdateRequest: FieldUpdateRequest;
};
export type UpdateFieldsBatchApiResponse = 
/** status 200 Successful Response */ FieldUpdateResponse;
export type UpdateFieldsBatchApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    fieldBatchUpdateRequest: FieldBatchUpdateRequest;
};
export type CreateCommentApiResponse = 
/** status 201 Successful Response */ CommentResponse;
export type CreateCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    createCommentRequest: CreateCommentRequest;
};
export type ListCommentsApiResponse = 
/** status 200 Successful Response */ ListCommentsResponse;
export type ListCommentsApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Filter by task ID */
    taskId?: string | null;
    filter?: {
        /** Filter by resolved state */
        resolved?: boolean | null;
    };
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type ListThreadsApiResponse = 
/** status 200 Successful Response */ ListThreadsResponse;
export type ListThreadsApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Filter by task ID */
    taskId?: string | null;
    filter?: {
        /** Filter by resolved state of root comment */
        resolved?: boolean | null;
    };
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type GetCommentApiResponse = 
/** status 200 Successful Response */ CommentResponse;
export type GetCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
};
export type UpdateCommentApiResponse = 
/** status 200 Successful Response */ CommentResponse;
export type UpdateCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
    updateCommentRequest: UpdateCommentRequest;
};
export type DeleteCommentApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
};
export type ResolveCommentApiResponse = 
/** status 200 Successful Response */ CommentResponse;
export type ResolveCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
};
export type UnresolveCommentApiResponse = 
/** status 200 Successful Response */ CommentResponse;
export type UnresolveCommentApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Comment ID */
    commentId: UuidPath;
};
export type ForceUnlockTicketDocumentApiResponse = 
/** status 200 Successful Response */ DocumentForceUnlockResponse;
export type ForceUnlockTicketDocumentApiArg = {
    ticketId: string;
    documentId: string;
    documentForceUnlockRequest: DocumentForceUnlockRequest;
};
export type VersionUpTicketDocumentApiResponse = 
/** status 200 Successful Response */ DocumentVersionUpResponse;
export type VersionUpTicketDocumentApiArg = {
    ticketId: string;
    documentId: string;
    documentVersionUpRequest: DocumentVersionUpRequest;
};
export type PatchDocumentApiResponse = 
/** status 200 Successful Response */ DocumentPatchResponse;
export type PatchDocumentApiArg = {
    ticketId: string;
    documentId: string;
    documentPatchRequest: DocumentPatchRequest;
};
export type DeleteTicketDocumentApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteTicketDocumentApiArg = {
    ticketId: string;
    documentId: string;
    /** Current version for optimistic locking */
    version: number;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    documentLockVersion?: number | null;
};
export type RecordSignaturesApiResponse = 
/** status 200 Successful Response */ RecordSignaturesResponse;
export type RecordSignaturesApiArg = {
    ticketId: string;
    taskId: string;
    recordSignaturesRequest: RecordSignaturesRequest;
};
export type RecordSignaturesBatchApiResponse = 
/** status 200 Successful Response */ RecordSignaturesBatchResponse;
export type RecordSignaturesBatchApiArg = {
    ticketId: string;
    taskId: string;
    recordSignaturesBatchRequest: RecordSignaturesBatchRequest;
};
export type GetSigningConfigurationApiResponse = 
/** status 200 Successful Response */ SigningConfigurationResponse;
export type GetSigningConfigurationApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    taskId: string;
};
export type ReplaceSigningConfigurationApiResponse = 
/** status 200 Successful Response */ SigningConfigurationResponse;
export type ReplaceSigningConfigurationApiArg = {
    ticketId: string;
    taskId: string;
    signingConfigurationRequest: SigningConfigurationRequest;
};
export type CreateEsignPackageApiResponse = 
/** status 201 Successful Response */
any | /** status 202 Async enqueue — creation deferred (no sender_view yet). */ CreateEsignPackageAcceptedResponse;
export type CreateEsignPackageApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** If true, run create_package inline (201 + sender_view). */
    sync?: boolean;
    createEsignPackageRequest: CreateEsignPackageRequest;
};
export type GetTicketActionsApiResponse = 
/** status 200 Successful Response */ GetTicketActionsResponse;
export type GetTicketActionsApiArg = {
    ticketId: string;
};
export type ListTicketsApiResponse = 
/** status 200 Successful Response */ ListTicketsResponse;
export type ListTicketsApiArg = {
    /** Filter by ticket state */
    state?: TicketState | null;
    /** Filter by workflow ID */
    workflowId?: string | null;
    /** Filter by WSS contract record unique ID (CRUID). Returns the single ticket the caller can see whose integration metadata carries this CRUID, or an empty list. Used by the contract-reroute flow to resolve a k2-minted CRUID to its ticket. */
    contractRecordUniqueId?: string | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
    /** Data to include in response. By default, only metadata is returned for performance. */
    include?: TicketIncludeParam[];
};
export type CreateTicketApiResponse = 
/** status 201 Successful Response */ CreateTicketResponse;
export type CreateTicketApiArg = {
    /** Optional external reference ID */
    referenceId?: string | null;
    createTicketRequest: CreateTicketRequest;
};
export type SearchTicketsApiResponse = 
/** status 200 Successful Response */ TicketSearchResponse;
export type SearchTicketsApiArg = {
    ticketSearchRequest: TicketSearchRequest;
};
export type CloneTicketApiResponse = 
/** status 201 Successful Response */ CreateTicketResponse;
export type CloneTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    cloneTicketRequest: CloneTicketRequest;
};
export type GetTicketApiResponse = 
/** status 200 Successful Response */ GetTicketResponse;
export type GetTicketApiArg = {
    ticketId: string;
    /** Data to include in response. By default (empty), all ticket fields are returned for backwards compatibility. `workflow` is opt-in only (never part of the default) and additionally returns the ticket's frozen workflow blueprint under `data.attributes.workflow` — this needs ticket-level view (not `workflow.view`) and is omitted for node-only grantees. */
    include?: TicketIncludeParam[];
};
export type DeleteTicketApiResponse = 
/** status 204 Successful Response */ void;
export type DeleteTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
};
export type UpdateTicketMetadataApiResponse = 
/** status 200 Successful Response */ GetTicketResponse;
export type UpdateTicketMetadataApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    updateTicketRequest: UpdateTicketRequest;
};
export type GetTicketStateApiResponse = 
/** status 200 Successful Response */ TicketStateResponse;
export type GetTicketStateApiArg = {
    ticketId: string;
};
export type EvaluateTicketFormVisibilityApiResponse = 
/** status 200 Successful Response */ FormVisibilityEvaluationResponse;
export type EvaluateTicketFormVisibilityApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    ticketFormVisibilityEvaluationRequest: TicketFormVisibilityEvaluationRequest;
};
export type PauseTicketApiResponse = 
/** status 200 Successful Response */ GetTicketResponse;
export type PauseTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    pauseTicketRequest: PauseTicketRequest;
};
export type ResumeTicketApiResponse = 
/** status 200 Successful Response */ GetTicketResponse;
export type ResumeTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    resumeTicketRequest: ResumeTicketRequest;
};
export type CancelTicketApiResponse = 
/** status 200 Successful Response */ GetTicketResponse;
export type CancelTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    cancelTicketRequest: CancelTicketRequest;
};
export type CompleteTicketApiResponse = 
/** status 200 Successful Response */ GetTicketResponse;
export type CompleteTicketApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    completeTicketRequest: CompleteTicketRequest;
};
export type ResetStageTasksApiResponse = 
/** status 200 Successful Response */ ResetStageTasksResponse;
export type ResetStageTasksApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    resetStageTasksRequest: ResetStageTasksRequest;
};
export type UpdateTicketAclApiResponse = 
/** status 200 Successful Response */ UpdateTicketAclResponse;
export type UpdateTicketAclApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    updateTicketAclRequest: UpdateTicketAclRequest;
};
export type ReassignTicketOwnerApiResponse = 
/** status 200 Successful Response */ GetTicketResponse;
export type ReassignTicketOwnerApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    reassignTicketOwnerRequest: ReassignTicketOwnerRequest;
};
export type ListTicketActivityLogsApiResponse = 
/** status 200 Successful Response */ ListActivityLogsResponse;
export type ListTicketActivityLogsApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
    /** Filter by resource type */
    resourceType?: string | null;
    /** Filter by action */
    action?: string | null;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page */
        size?: number;
    };
};
export type ShareExternallyApiResponse = 
/** status 200 Successful Response */ ShareExternallyResponse;
export type ShareExternallyApiArg = {
    ticketId: string;
    shareExternallyRequest: ShareExternallyRequest;
};
export type ShareInternallyApiResponse = 
/** status 200 Successful Response */ ShareInternallyResponse;
export type ShareInternallyApiArg = {
    ticketId: string;
    shareInternallyRequest: ShareInternallyRequest;
};
export type ResolveRenewalWorkflowApiResponse = 
/** status 200 Successful Response */ RenewalWorkflowResponse;
export type ResolveRenewalWorkflowApiArg = {
    /** Pilot document id of the contract being renewed. */
    sourceDocumentId: string;
};
export type BulkReassignTasksApiResponse = 
/** status 200 Successful Response */ BulkReassignResponse;
export type BulkReassignTasksApiArg = {
    bulkReassignRequest: BulkReassignRequest;
};
export type SearchSuppliersApiResponse = 
/** status 200 Successful Response */ ListSuppliersResponse;
export type SearchSuppliersApiArg = {
    /** Search query (minimum 2 characters) */
    q: string;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page (max 50) */
        size?: number;
    };
};
export type ListContractTypesApiResponse = 
/** status 200 Successful Response */ ListContractTypesResponse;
export type ListContractTypesApiArg = {
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page (max 1000) */
        size?: number;
    };
};
export type GetIntakeFormLinkApiResponse = 
/** status 200 Successful Response */ GetIntakeFormLinkResponse;
export type GetIntakeFormLinkApiArg = {
    /** Unique workflow identifier (UUID) */
    workflowId: UuidPath;
    /** WSS reference ID for supplier prepopulation */
    referenceId?: string | null;
};
export type GetExpressionAstSchemaApiResponse = 
/** status 200 Successful Response */ any;
export type GetExpressionAstSchemaApiArg = void;
export type SearchCompaniesApiResponse = 
/** status 200 Successful Response */ ListCompaniesResponse;
export type SearchCompaniesApiArg = {
    /** Search query (minimum 2 characters) */
    q: string;
    page?: {
        /** Page number (1-indexed) */
        number?: number;
        /** Items per page (max 1000) */
        size?: number;
    };
};
export type RequestDocumentUploadApiResponse = 
/** status 201 Successful Response */ DocumentUploadUrlResponse;
export type RequestDocumentUploadApiArg = {
    ticketId: string;
    ticketDocumentUploadUrlRequest: TicketDocumentUploadUrlRequest;
};
export type UploadCompleteApiResponse = 
/** status 200 Successful Response */ DocumentUploadCompleteResponse;
export type UploadCompleteApiArg = {
    ticketId: string;
    documentId: string;
    documentUploadCompleteRequest: DocumentUploadCompleteRequest;
};
export type GetDownloadUrlApiResponse = DocumentDownloadUrlResponse | /** status 202 Conversion has been requested but is not yet ready. ``download_url`` is null; poll this endpoint until the response is 200. */ DocumentDownloadUrlResponse;
export type GetDownloadUrlApiArg = {
    ticketId: string;
    documentId: string;
    /** Specific version to retrieve. Omit for latest. */
    documentVersion?: number | null;
    /** Which format to download. ``original`` returns the uploaded file; ``sfdt`` returns the cached SFDT conversion; ``pdf`` is produced from DOCX via Muse; ``docx`` is produced from legacy ``.doc`` or PDF uploads via Muse. */
    format?: "original" | "sfdt" | "pdf" | "docx";
};
export type GetDocumentComparisonApiResponse = 
/** status 200 Successful Response */
DocumentComparisonResponse | /** status 202 Comparison has been requested but is not yet ready. ``download_url`` is null; poll the same endpoint until the response is 200. */ DocumentComparisonResponse;
export type GetDocumentComparisonApiArg = {
    ticketId: string;
    documentId: string;
    /** Newer version (target) in the diff */
    newerVersion: number;
    /** Older version (reference) in the diff */
    olderVersion: number;
};
export type GetTicketVersionApiResponse = 
/** status 200 Successful Response */ TicketVersionResponse;
export type GetTicketVersionApiArg = {
    /** Unique ticket identifier (UUID) */
    ticketId: UuidPath;
};
export type ScribylLockDocumentApiResponse = 
/** status 204 Successful Response */ void;
export type ScribylLockDocumentApiArg = {
    /** Ticket UUID */
    ticketId: string;
    /** Document id on the ticket */
    documentId: string;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    "X-Document-Lock-Version"?: number | null;
    scribylDocumentLockRequest: ScribylDocumentLockRequest;
};
export type ScribylUnlockDocumentApiResponse = 
/** status 204 Successful Response */ void;
export type ScribylUnlockDocumentApiArg = {
    /** Ticket UUID */
    ticketId: string;
    /** Document id on the ticket */
    documentId: string;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    "X-Document-Lock-Version"?: number | null;
    scribylDocumentUnlockRequest: ScribylDocumentUnlockRequest;
};
export type GetWssWorkflowsApiResponse = 
/** status 200 Successful Response */ WorkflowListResponse;
export type GetWssWorkflowsApiArg = void;
export type UpdateWssContractNegotiationApiResponse = 
/** status 200 Successful Response */ ContractNegotiationUpdateResponse;
export type UpdateWssContractNegotiationApiArg = {
    /** Contract record unique ID from WSS */
    contractRecordUniqueId: string;
};
export type CheckResult = {
    name: string;
    passed: boolean;
    details?: string | null;
};
export type HealthcheckReport = {
    healthy: boolean;
    checks: CheckResult[];
};
export type FieldUsageResponseAttributes = {
    /** Display name of the workflow */
    workflow_name: string;
};
export type ResourceIdentifier = {
    /** JSON:API resource type string */
    type: string;
    /** Resource identifier (UUID) */
    id: string;
};
export type Links = {
    /** URL of the current resource or collection */
    self?: string | null;
    /** URL of a related resource */
    related?: string | null;
    /** URL of the first page of results */
    first?: string | null;
    /** URL of the last page of results */
    last?: string | null;
    /** URL of the previous page of results; null on the first page */
    prev?: string | null;
    /** URL of the next page of results; null on the last page */
    next?: string | null;
    [key: string]: any;
};
export type RelationshipData = {
    /** Resource identifier(s) for the related resource(s) */
    data?: ResourceIdentifier | ResourceIdentifier[] | null;
    /** Links to fetch the relationship */
    links?: Links | null;
    /** Non-standard metadata for the relationship */
    meta?: {
        [key: string]: any;
    } | null;
};
export type FieldUsageResponseData = {
    type?: "workflow-field-usages";
    id: string;
    attributes: FieldUsageResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type FieldUsagesResponse = {
    data: FieldUsageResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ErrorLinks = {
    /** A link that leads to further details about this particular occurrence of the problem. */
    about?: string | null;
    /** A link that identifies the type of error that this particular error is an instance of. */
    type?: string | null;
};
export type ErrorSource = {
    /** JSON Pointer (RFC 6901) to the value in the request document that caused the error. */
    pointer?: string | null;
    /** URI query parameter that caused the error. */
    parameter?: string | null;
    /** Name of a single request header which caused the error. */
    header?: string | null;
};
export type ErrorData = {
    /** A unique identifier for this particular occurrence of the problem. */
    id?: string | null;
    links?: ErrorLinks | null;
    /** The HTTP status code applicable to this problem, expressed as a string value. */
    status: string;
    /** An application-specific error code, expressed as a string value. */
    code: string;
    /** A short, human-readable summary of the problem. Should not change from occurrence to occurrence. */
    title: string;
    /** A human-readable explanation specific to this occurrence of the problem. */
    detail?: string | null;
    source?: ErrorSource | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ErrorResponse = {
    errors: ErrorData[];
    meta?: {
        [key: string]: any;
    } | null;
    links?: ErrorLinks | null;
};
export type ValidationError = {
    loc: (string | number)[];
    msg: string;
    type: string;
    input?: any;
    ctx?: object;
};
export type HttpValidationError = {
    detail?: ValidationError[];
};
export type UuidStr = string;
export type DocumentType = "contract" | "exhibit" | "redline" | "nda" | "attachment" | "template";
export type ContentStatus = "pending" | "ready" | "failed";
export type ConversionStatus = "pending" | "ready" | "failed";
export type DocumentConversionSchema = {
    /** Conversion lifecycle: ``pending`` (requested, not yet produced), ``ready`` (downloadable), or ``failed`` (terminally rejected; will not be retried). */
    status: ConversionStatus;
    /** When the conversion was enqueued; null if never requested. */
    requested_at?: string | null;
    /** When the conversion completed; set only when ``status=ready``. */
    generated_at?: string | null;
    /** When the conversion failed terminally; set only when ``status=failed``. */
    failed_at?: string | null;
    /** Error code for a terminal failure — either Muse's (e.g. ``document_parsing_error.condition_missing_period``) or a K2-originated ``k2_error.*`` sentinel (e.g. ``k2_error.source_document_missing``); null when the conversion has not failed or no code was available. */
    error_code?: string | null;
};
export type DocumentVersionMetaSchema = {
    /** Document version number (1-based) */
    version: number;
    /** Processing status of this version (pending, ready, failed) */
    content_status: ContentStatus;
    /** User ID who uploaded this version */
    created_by?: string | null;
    /** Pilot-internal document identifier */
    pilot_document_id?: string | null;
    /** When this version was uploaded */
    created_at: string;
    /** File extension of this version's content (e.g. 'docx', 'pdf'). Per-version because a re-upload can change format; the frontend uses this to pick the viewer (SFDT for docx, native viewer for pdf) for the specific version being opened. */
    file_format?: string | null;
    /** Whether this specific version can be opened in the browser viewer. True when the version is ready and either the format has a native viewer (e.g. PDF) or its SFDT conversion is complete. */
    is_viewable: boolean;
    /** Pilot DocumentHandler ID associated with this version */
    handler_id?: number | null;
    /** Derived-format conversions for this version, keyed by format ('sfdt', 'pdf', 'docx'). Each entry reports status (pending/ready/failed), timestamps, and — on terminal failure — the Muse error_code. Empty when no conversion has been requested for this version. */
    conversions?: {
        [key: string]: DocumentConversionSchema;
    };
};
export type DocumentUploadUrlResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Presigned PUT URL(s) pointing to Pilot's client.bucket */
    upload_urls: string[];
    /** ID of the created or updated document */
    document_id: string;
    /** Expected file size in bytes (must match Content-Length header on PUT) */
    content_length: number;
    /** URL expiration time in seconds */
    expires_in: number;
    /** Owner version after document registration. Document operations sit outside the owner's optimistic-locking system, so this is the current persisted version of the ticket or workflow — unchanged by the upload itself. */
    version: number;
    /** Pilot upload ID; pass to upload-complete after PUT */
    upload_id: string;
};
export type DocumentUploadUrlResponseData = {
    type?: "documents";
    id: string;
    attributes: DocumentUploadUrlResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentUploadUrlResponse = {
    data: DocumentUploadUrlResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type UuidPath = string;
export type UploadFieldValue = {
    /** Field value string to associate with this document upload */
    value: string;
};
export type UploadReferenceFieldValue = {
    /** Workday resource identifier (WID) */
    resource_id: string;
    /** Human-readable display name for the reference */
    default_value: string;
};
export type UploadField = {
    /** Unified Field UUID */
    id: string;
    values: (UploadFieldValue | UploadReferenceFieldValue)[];
};
export type DocumentUploadUrlAttributes = {
    /** Current owner version. Optional and not enforced — document uploads sit outside the owner's optimistic-locking system; accepted for caller compatibility. */
    version?: number | null;
    /** Existing document ID for re-upload of a new version. Omit for a new document. */
    document_id?: string | null;
    /** Filename of the document to upload */
    name: string;
    /** MIME type of the file */
    content_type: string;
    /** File size in bytes */
    content_length: number;
    /** Document's role: contract | attachment | template. Omit to use the owner's default (ATTACHMENT for tickets, TEMPLATE for workflows). */
    document_type?: DocumentType | null;
    /** Optional Unified Field values to set on the document. Each entry identifies a field by UUID and supplies one or more values. */
    fields?: UploadField[] | null;
    /** How to handle a name collision with an existing document. true — rename the incoming file by appending '(N)' before the extension (e.g. 'doc(1).docx'). false — treat this upload as a new version of the existing document with the same name. Omit when document_id is set (re-uploads are already explicitly versioned), or when the caller is certain the name is unique. */
    rename?: boolean | null;
};
export type DocumentUploadUrlRequestData = {
    type: "documents";
    attributes: DocumentUploadUrlAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentUploadUrlRequest = {
    data: DocumentUploadUrlRequestData;
};
export type DocumentUploadCompleteResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** ID of the completed document */
    document_id: string;
    /** Owner version of the parent resource after completion. Tickets increment; workflows are unchanged (in-place definition update). */
    version: number;
};
export type DocumentUploadCompleteResponseData = {
    type?: "documents";
    id: string;
    attributes: DocumentUploadCompleteResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentUploadCompleteResponse = {
    data: DocumentUploadCompleteResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type DocumentUploadCompleteAttributes = {
    /** Pilot upload ID from upload-request response */
    upload_id: string;
};
export type DocumentUploadCompleteRequestData = {
    type: "documents";
    attributes: DocumentUploadCompleteAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentUploadCompleteRequest = {
    data: DocumentUploadCompleteRequestData;
};
export type DocumentFormat = "original" | "sfdt" | "pdf" | "docx" | "doc";
export type DocumentDownloadStatus = "ready" | "pending";
export type DocumentDownloadUrlResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Presigned GET URL for downloading the file. Null when ``download_status=pending`` (derived-format conversion in progress). */
    download_url?: string | null;
    /** URL expiration time in seconds (0 when pending) */
    expires_in?: number;
    /** Format of the downloaded payload (original upload or derived conversion) */
    format?: DocumentFormat;
    /** ``ready`` when ``download_url`` is set; ``pending`` for derived-format conversions still being generated (HTTP 202; poll the same endpoint). */
    download_status?: DocumentDownloadStatus;
    /** File size in bytes for ``format=original`` downloads. Null for derived formats (conversion size is not persisted), when ``download_status=pending``, or when size metadata is unavailable (e.g. legacy documents uploaded before this field was persisted). */
    content_length?: number | null;
};
export type DocumentDownloadUrlResponseData = {
    type?: "documents";
    id: string;
    attributes: DocumentDownloadUrlResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentDownloadUrlResponse = {
    data: DocumentDownloadUrlResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ResourceName = string;
export type FieldPlaceholderMappingSchema = {
    kind: "field";
    /** The literal DOCX token, exactly as ``template_metadata.placeholders`` reports it. */
    placeholder: ResourceName;
    /** The active client field api_name whose value fills this placeholder. */
    api_name: ResourceName;
};
export type SignerPlaceholderMappingSchema = {
    kind?: "signer";
    /** The literal DOCX token, exactly as ``template_metadata.placeholders`` reports it. */
    placeholder: ResourceName;
    /** 1-based signing slot this placeholder belongs to. */
    slot: number;
    /** Signer field to place here. ``signature``/``name``/``email``/``date`` map to the vendor's core tabs; any other lowercase identifier renders a free-text tab the signer fills in. */
    field_name: string;
};
export type PlaceholderMappingsResponseAttributes = {
    /** The document's per-document optimistic-concurrency token. */
    document_lock_version: number;
    /** The persisted list, as stored. */
    placeholder_mappings: (({
        kind: "field";
    } & FieldPlaceholderMappingSchema) | ({
        kind: "signer";
    } & SignerPlaceholderMappingSchema))[];
};
export type PlaceholderMappingsResponseData = {
    type?: "documents";
    id: string;
    attributes: PlaceholderMappingsResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type PlaceholderMappingsResponseMeta = {
    /** Workflow version after the save. Unchanged for a draft; ``version + 1`` when the write forked a new draft from a published workflow. */
    version: number;
};
export type PlaceholderMappingsResponse = {
    data: PlaceholderMappingsResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta: PlaceholderMappingsResponseMeta;
    links?: Links | null;
};
export type VersionInt = number;
export type PlaceholderMappingsAttributes = {
    /** Current workflow version for optimistic locking */
    version: VersionInt;
    /** Complete, ordered list of bindings from a template placeholder to what fills it — a Unified Field ``api_name`` (``kind: "field"``) or a signing slot's field (``kind: "signer"``), e.g. ``[{"kind": "field", "placeholder": "Fruit Color", "api_name": "CU.0.fruit_color"}, {"kind": "signer", "placeholder": "Signer Full Name", "slot": 1, "field_name": "name"}]``. Every ``placeholder`` must be one of the template's ``template_metadata.placeholders`` and must not be a canonical signer token (``signer_1.name``) or a conditional gate, and no placeholder may repeat. Every ``api_name`` must be an active client field. A ``signer`` entry also **declares** its slot, so a template written entirely in friendly text still gets vendor anchors. The order given is the order returned. */
    placeholder_mappings?: (({
        kind: "field";
    } & FieldPlaceholderMappingSchema) | ({
        kind: "signer";
    } & SignerPlaceholderMappingSchema))[];
};
export type PlaceholderMappingsRequestData = {
    type: "documents";
    attributes: PlaceholderMappingsAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type PlaceholderMappingsRequest = {
    data: PlaceholderMappingsRequestData;
};
export type WorkflowCreateResponseAttributes = {
    /** Workflow name */
    name: string;
    /** Initial version number (1) */
    version: number;
    /** Published state (initially false) */
    published: boolean;
    /** When the workflow was created */
    created_at: string;
    /** User ID who created the workflow */
    created_by: string;
};
export type WorkflowCreateResponseData = {
    type?: "workflows";
    id: string;
    attributes: WorkflowCreateResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CreateWorkflowResponse = {
    data: WorkflowCreateResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type PartyType = "internal" | "counter";
export type Party = {
    id: string;
    name?: string;
    type: PartyType;
};
export type FieldLookupTableReference = {
    field_lookup_table_id: string;
    field_ids: string[];
};
export type FieldDefinition = {
    id: string;
    name: string;
    description?: string;
    data_type: string;
    field_lookup_table?: FieldLookupTableReference | null;
};
export type FormFieldReference = {
    field_id: string;
};
export type ConditionReference = {
    condition_id: string;
};
export type FormQuestion = {
    id: string;
    name: string;
    description?: string;
    is_required?: boolean;
    is_read_only?: boolean;
    section?: string;
    form_field: FormFieldReference;
    visible_condition?: ConditionReference | null;
};
export type UploadMode = "not_available" | "optional" | "required";
export type TemplateMode = "disabled" | "requester_choice" | "always";
export type PathRule = "choose_one_path" | "allow_both";
export type FormDocumentConfig = {
    allow_doc_submission_or_generation?: boolean;
    upload_mode?: UploadMode;
    template_mode?: TemplateMode;
    path_rule?: PathRule;
    allow_completing_with_no_document?: boolean;
};
export type Form = {
    id: string;
    name: string;
    description?: string;
    questions?: FormQuestion[];
    document_template_ids?: string[];
    document_config?: FormDocumentConfig;
};
export type ExpressionParam = {
    name: string;
    type: string;
    value?: any | null;
};
export type Expression = {
    id: string;
    name: string;
    description?: string;
    result_type: string;
    expression?: string;
    expression_params?: ExpressionParam[];
};
export type ExpressionReference = {
    expression_id: string;
    is_local_expression?: boolean;
    expression_params?: ExpressionParam[];
};
export type Condition = {
    id: string;
    name: string;
    description?: string;
    expression: ExpressionReference;
};
export type ConditionalTextReference = {
    gate: string;
    condition_id: string;
};
export type ActionType = "notification" | "webhook" | "field_update" | "document_fill" | "document_parse" | "document_archive" | "esign_package_create";
export type Action = {
    id: string;
    name: string;
    type: ActionType;
    description?: string;
    action_params?: ExpressionParam[];
};
export type AclPrincipalType = "user" | "department" | "role" | "implicit";
export type AclPrincipal = {
    /** Principal type: `user`, `department`, `role`, or `implicit`. */
    type: AclPrincipalType;
    /** Concrete grantee id for `user`/`department`/`role`; an implicit-role placeholder token (e.g. `submitter`, `task_assignees:<task_id>`, `field_users:<field_id>`) for `implicit`. */
    id: string;
};
export type ArchiveLocation = {
    /** Pilot folder ID where documents are filed on ticket completion. */
    pilot_folder_id?: number | null;
    /** ID of an Expression in the workflow expression_library that evaluates to the subfolder path within the base folder. The expression should use a TemplateNode with delimiter='/' and resolve ticket field values. */
    file_path_expression_id?: string | null;
    /** ID of an Expression in the workflow expression_library that evaluates to the file name for the archived document. When set, Pilot stores the document under this name instead of its original upload name. */
    file_name_expression_id?: string | null;
};
export type CustomNotification = {
    /** Client-generated UUID; stable key for upserts. */
    id: string;
    user_ids?: number[];
    message?: string;
};
export type DefaultSigner = {
    /** Global signer index (matches signing_slot / participant order) */
    order: number;
    name?: string | null;
    email?: string | null;
    field_values?: {
        [key: string]: string;
    };
    label?: string | null;
    party?: ("N/A" | "Internal" | "External") | null;
};
export type WorkflowSigningConfig = {
    default_signers?: {
        [key: string]: DefaultSigner[];
    };
};
export type WorkflowSettings = {
    accepted_file_types?: string[];
    acl?: {
        [key: string]: AclPrincipal[];
    };
    archive_location?: ArchiveLocation;
    custom_notifications?: CustomNotification[];
    /** ID of an Expression in the workflow expression_library that evaluates to the ticket name string. Only used when use_system_default_ticket_name is False. */
    ticket_naming_convention_expression_id?: string | null;
    /** When False, ticket_naming_convention_expression_id is evaluated to name the ticket. */
    use_system_default_ticket_name?: boolean;
    /** When True (default), a stage is automatically completed and the ticket advances once all of its tasks are done. On the final stage the ticket itself is completed. Clients that persist or send null (clone + AI-generated workflows that omit this setting) are coerced to True at input time. */
    auto_complete_stages?: boolean;
    /** User ID to set as the owner of tickets created from this workflow. When unset (None), the ticket owner defaults to the creating user. The create API does not accept a client-supplied owner, so this workflow setting is the only way to deviate from creator-as-owner. */
    default_owner_user_id?: string | null;
    /** Authoring-time esign defaults keyed by signer-collection task id. */
    signing_config?: WorkflowSigningConfig;
    /** Implicit-only ACL map granting default tiers to submitter and task-assignee placeholders on tickets from this workflow. */
    implicit_role_permissions?: {
        [key: string]: AclPrincipal[];
    };
    /** Free-text hint, authored by a workflow admin, describing when this workflow should be used. Used by Ask AI to suggest a workflow for a new ticket. */
    routing_hint?: string | null;
};
export type WorkflowDefinition = {
    /** Workflow definition ID (assigned by server on create) */
    id?: string | null;
    /** Workflow description */
    description?: string | null;
    /** Ordered list of stage definitions, each containing tasks, conditions, and gate rules */
    stages?: {
        [key: string]: any;
    }[];
    /** Counterparty definitions for external user workflows */
    parties?: Party[];
    /** Document template definitions for auto-generation */
    documents?: {
        [key: string]: any;
    }[];
    /** Form ID for the intake form shown at ticket creation */
    intake_form_id?: string | null;
    /** Reusable field definitions available across all stages */
    field_library?: FieldDefinition[];
    /** Reusable form definitions available across all stages */
    form_library?: Form[];
    /** Named expressions for computed values and conditions */
    expression_library?: Expression[];
    /** Named conditions that control task visibility and stage gates */
    condition_library?: Condition[];
    /** Links template document conditional-text gates to conditions */
    conditional_texts_library?: ConditionalTextReference[];
    /** Named actions triggered by workflow events */
    action_library?: Action[];
    /** Workflow-level settings: archive location, accepted file types, custom completion notifications, ticket-naming convention, auto-complete-stages behavior, and default signers. */
    settings?: WorkflowSettings;
};
export type IntegrationType = "none" | "wss_only" | "procurement";
export type WorkflowCreateAttributes = {
    /** Workflow name */
    name: ResourceName;
    /** Complete workflow definition blueprint */
    workflow_definition: WorkflowDefinition;
    /** WSS / Procurement integration type, set once at create (immutable afterward). */
    integration_type?: IntegrationType | null;
    /** Workday contract type id. Only settable when ``integration_type`` is ``procurement``; validated against the Workday contract types catalog. May be omitted while the workflow is a draft, but required before it can be published. */
    contract_type_id?: string | null;
    /** Optional access control list keyed by permission. The workflow stays public/open to the tenant unless it has a non-empty ``viewer`` list — only a viewer grant restricts visibility; editor/commenter-only grants leave it open. The creator is automatically kept as an editor. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
};
export type WorkflowCreateRequestData = {
    type: "workflows";
    attributes: WorkflowCreateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CreateWorkflowRequest = {
    data: WorkflowCreateRequestData;
};
export type DocumentSource = "uploaded" | "generated";
export type DocumentStorage = "pilot" | "muse";
export type SigningStatus = "none" | "pending" | "signed";
export type DocumentLockingMetadataSchema = {
    /** Whether the document is locked for collaborative editing */
    is_locked?: boolean;
    /** Human-readable lock reason (e.g. editor display name) */
    reason?: string | null;
    /** When the lock was acquired */
    lock_acquired_at?: string | null;
    /** When the lock expires, if applicable */
    lock_expires_at?: string | null;
};
export type PaperType = "first_party" | "third_party";
export type ParsedSignerFieldSchema = {
    /** 1-based signing slot index within the document */
    slot: number;
    /** Signer field name: ``signature``/``name``/``email``/``date`` or a freeform field name */
    field_name: string;
};
export type TemplateMetadataSchema = {
    /** When the template was parsed (UTC, ISO 8601). */
    parsed_at: string;
    /** All top-level ``{field}`` placeholder tokens found in the template, exactly as they appear in the DOCX (sorted). A token is not necessarily an api_name: a template may be authored with human-readable placeholders and bound to fields via ``placeholder_mappings``. */
    placeholders: string[];
    /** The conditional-block **gate names** — the booleans that include or exclude a block at fill time (sorted). Despite the name, these are gate identifiers, not `{field}` placeholders. At fill time each gate is matched (case-insensitively) to a workflow ``condition_library`` entry and that condition's expression is evaluated; a gate with no matching condition is omitted from the fill, leaving that block unresolved (K2 does not infer a gate from a same-named field value). */
    conditional_placeholders: string[];
    /** Discovered field api_names matched to a Unified Field (sorted). */
    valid_fields: string[];
    /** Discovered field api_names with no matching Unified Field (sorted); surfaced so the author can fix them. */
    invalid_fields: string[];
    /** Signer fields extracted from ``signer_N.field`` placeholders. */
    signer_fields?: ParsedSignerFieldSchema[];
};
export type TemplateParseErrorSchema = {
    /** Muse error code (e.g. ``document_parsing_error.condition_missing_period``); null when omitted. */
    code?: string | null;
};
export type WorkflowDocument = {
    /** Unique identifier for this document */
    document_id: string;
    /** Filename of the document */
    name: string;
    /** How the document was added (uploaded, generated, etc.) */
    source: DocumentSource;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the current version */
    content_status: ContentStatus;
    /** Storage backend (pilot or muse) */
    storage: DocumentStorage;
    /** Current version number (increments on re-upload) */
    document_version?: number;
    /** Per-document optimistic-concurrency token (distinct from document_version, the content re-upload counter). Optional on writes: when supplied on a document mutation it is enforced with a 409 on mismatch; omit it to fall back to ticket-version OCC. */
    document_lock_version?: number;
    /** Chronological list of all document versions with their metadata */
    version_history?: DocumentVersionMetaSchema[];
    /** Whether the document can be opened in the browser viewer. True when content is ready and either the format has a native viewer (e.g. PDF) or the SFDT conversion for the current version is complete. */
    is_viewable: boolean;
    /** Pilot-internal document identifier */
    pilot_document_id?: string | null;
    /** Pilot FileAttachment identifier. Set after a ticket-completion convert step transforms an ATTACHMENT-typed document into a Pilot FileAttachment. */
    pilot_attachment_id?: string | null;
    /** In-progress upload ID (null once complete) */
    upload_id?: string | null;
    /** Template ID if document was generated from a template */
    template_id?: string | null;
    /** Original template document ID for generated documents */
    source_template_document_id?: string | null;
    /** E-signature lifecycle state (null for workflow documents) */
    signing_status?: SigningStatus | null;
    /** List of signer records for e-signature documents */
    signers?: {
        [key: string]: any;
    }[];
    /** When the document was generated from a template */
    generated_at?: string | null;
    /** Collaborative-edit lock metadata (Scribyl inbound S2S and future callers) */
    locking_metadata?: DocumentLockingMetadataSchema;
    /** Whether the document is the originator's paper (first_party) or the counterparty's paper (third_party). Immutable after attach. */
    paper_type?: PaperType;
    /** Parsed field metadata. Set on TEMPLATE documents after DOCX parsing completes; null otherwise. */
    template_metadata?: TemplateMetadataSchema | null;
    /** Author-saved bindings from a template placeholder to what fills it — a Unified Field ``api_name`` or a signing slot's field — for templates whose placeholders are human-readable rather than canonical tokens. Every ``placeholder`` is drawn from ``template_metadata.placeholders``. Ordered, and returned in the order it was saved. Empty means every placeholder is resolved as an api_name itself. Written via ``PUT /workflows/{id}/documents/{document_id}/placeholder-mappings``. */
    placeholder_mappings?: (({
        kind: "field";
    } & FieldPlaceholderMappingSchema) | ({
        kind: "signer";
    } & SignerPlaceholderMappingSchema))[];
    /** Whether the template's field parse succeeded. True by default; false only when a TEMPLATE document's parse permanently failed at Muse (content_status may still be ready). See ``template_error`` for the reason. */
    template_valid?: boolean;
    /** Why the template parse permanently failed. Set only when ``template_valid`` is false; null otherwise. */
    template_error?: TemplateParseErrorSchema | null;
};
export type WorkflowDefinitionResponse = {
    /** Workflow definition ID (assigned by server on create) */
    id?: string | null;
    /** Workflow description */
    description?: string | null;
    /** Ordered list of stage definitions, each containing tasks, conditions, and gate rules */
    stages?: {
        [key: string]: any;
    }[];
    /** Counterparty definitions for external user workflows */
    parties?: Party[];
    /** Template document definitions with computed is_viewable and content_status fields */
    documents?: WorkflowDocument[];
    /** Form ID for the intake form shown at ticket creation */
    intake_form_id?: string | null;
    /** Reusable field definitions available across all stages */
    field_library?: FieldDefinition[];
    /** Reusable form definitions available across all stages */
    form_library?: Form[];
    /** Named expressions for computed values and conditions */
    expression_library?: Expression[];
    /** Named conditions that control task visibility and stage gates */
    condition_library?: Condition[];
    /** Links template document conditional-text gates to conditions */
    conditional_texts_library?: ConditionalTextReference[];
    /** Named actions triggered by workflow events */
    action_library?: Action[];
    /** Workflow-level settings: archive location, accepted file types, custom completion notifications, ticket-naming convention, auto-complete-stages behavior, and default signers. */
    settings?: WorkflowSettings;
};
export type WorkflowAttributes = {
    /** Workflow name */
    name: string;
    /** Workflow description shown to end users. */
    description?: string;
    /** Full workflow definition. Included when ?include=workflow_definition is specified. */
    workflow_definition?: WorkflowDefinitionResponse | null;
    /** Current version number (incremented on each update) */
    version: number;
    /** Whether this workflow version is published and available for ticket creation */
    published: boolean;
    /** WSS / Procurement integration type of the workflow (``none`` for plain workflows). */
    integration_type?: IntegrationType;
    /** Workday contract type id; set only for ``procurement`` workflows. */
    contract_type_id?: string | null;
    /** Workday contract type display name; set only for ``procurement`` workflows. */
    contract_type_name?: string | null;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who created the workflow */
    created_by?: string | null;
    /** User ID who last updated the workflow */
    updated_by?: string | null;
    /** Access control list keyed by permission name. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
};
export type WorkflowResponseData = {
    type?: "workflows";
    id: string;
    attributes: WorkflowAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListWorkflowsResponse = {
    data: WorkflowResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type WorkflowIncludeParam = "workflow_definition" | "acl";
export type WorkflowSortParam = "name" | "-name" | "created_at" | "-created_at" | "updated_at" | "-updated_at";
export type GetWorkflowResponse = {
    data: WorkflowResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type UpdateWorkflowResponse = {
    data: WorkflowResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type WorkflowUpdateAttributes = {
    /** Workflow name */
    name: ResourceName;
    /** Updated workflow definition (creates a new immutable version) */
    workflow_definition: WorkflowDefinition;
    /** Workday contract type id, settable only on procurement workflows. Omit to leave unchanged; required before publishing. */
    contract_type_id?: string | null;
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type WorkflowUpdateRequestData = {
    type: "workflows";
    attributes: WorkflowUpdateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateWorkflowRequest = {
    data: WorkflowUpdateRequestData;
};
export type WorkflowPublishResponseAttributes = {
    /** Workflow name */
    name: string;
    /** Published version number */
    version: number;
    /** Published state (true after publish) */
    published: boolean;
    /** When the workflow was published. This is the row's last-write timestamp (``updated_at``, falling back to ``created_at``), not an independently recorded publish event. */
    published_at: string;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
};
export type WorkflowPublishResponseData = {
    type?: "workflows";
    id: string;
    attributes: WorkflowPublishResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type PublishWorkflowResponse = {
    data: WorkflowPublishResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type WorkflowPublishAttributes = {
    /** Version to publish */
    version: VersionInt;
};
export type WorkflowPublishRequestData = {
    type: "workflows";
    attributes: WorkflowPublishAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type PublishWorkflowRequest = {
    data: WorkflowPublishRequestData;
};
export type WorkflowCloneAttributes = {
    /** Name for the cloned workflow. If omitted, the server defaults to "{original_name} (Copy)". */
    new_name?: string | null;
};
export type WorkflowCloneRequestData = {
    type: "workflows";
    attributes: WorkflowCloneAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CloneWorkflowRequest = {
    data: WorkflowCloneRequestData;
};
export type UpdateWorkflowAclResponseAttributes = {
    /** Complete ACL after the update, keyed by permission name */
    acl: {
        [key: string]: AclPrincipal[];
    };
};
export type UpdateWorkflowAclResponseData = {
    type?: "workflows";
    id: string;
    attributes: UpdateWorkflowAclResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateWorkflowAclResponse = {
    data: UpdateWorkflowAclResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type UpdateWorkflowAclAttributes = {
    /** ACL updates keyed by permission. Only specified permissions are replaced; omitted ones remain unchanged. `implicit` principals are rejected here with a 400: an implicit-only workflow ACL would resolve to an empty principal set, which the default-open view rule reads as *unrestricted* — the opposite of the intent. Implicit principals are valid on ticket ACLs and on the stage/task ACLs inside `workflow_definition`. */
    acl: {
        [key: string]: AclPrincipal[];
    };
};
export type UpdateWorkflowAclRequestData = {
    type: "workflows";
    attributes: UpdateWorkflowAclAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateWorkflowAclRequest = {
    data: UpdateWorkflowAclRequestData;
};
export type ValidationErrorItem = {
    /** Machine-readable code */
    code: string;
    /** Human-readable message */
    message: string;
    /** JSON path to the problematic element */
    path?: string | null;
    /** Structured data for the item (e.g. stage_id, task_id) */
    context?: {
        [key: string]: any;
    };
};
export type ValidationWarning = {
    /** Machine-readable code */
    code: string;
    /** Human-readable message */
    message: string;
    /** JSON path to the problematic element */
    path?: string | null;
    /** Structured data for the item (e.g. stage_id, task_id) */
    context?: {
        [key: string]: any;
    };
};
export type WorkflowValidationResult = {
    /** Whether the workflow definition passed validation */
    valid: boolean;
    /** Validation errors that prevent publishing */
    errors?: ValidationErrorItem[];
    /** Non-blocking warnings about potential issues */
    warnings?: ValidationWarning[];
};
export type ValidationCheckGroup = "structure" | "references" | "conditions" | "expressions" | "forms" | "tasks" | "documents" | "signing" | "integration" | "warnings";
export type ValidationRunMeta = {
    /** Check groups that ran, in declaration order */
    checks: ValidationCheckGroup[];
    /** True when only some groups ran. `valid` then speaks for those groups only and is not a publish gate -- publish always runs every group. */
    partial: boolean;
};
export type ValidateWorkflowResponse = {
    /** Validation results including errors and warnings */
    data: WorkflowValidationResult;
    /** Metadata about the validation run */
    meta?: ValidationRunMeta | null;
};
export type WorkflowValidateAttributes = {
    /** Workflow definition to validate without saving */
    workflow_definition: WorkflowDefinition;
    /** WSS / Procurement integration type the definition is being validated as */
    integration_type?: IntegrationType | null;
    /** Workday contract type id. */
    contract_type_id?: string | null;
    /** Run only these validation check groups. Omit to run all of them. A narrowed run reports `valid` for the groups that ran only -- it is not a publish gate; see `meta.partial` on the response. */
    checks?: ValidationCheckGroup[] | null;
};
export type WorkflowValidateRequestData = {
    type: "workflows";
    attributes: WorkflowValidateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ValidateWorkflowRequest = {
    data: WorkflowValidateRequestData;
};
export type FieldLookupTableReferenceSchema = {
    /** Field lookup table id */
    field_lookup_table_id: string;
    /** Field ids configured for this workflow field from the field lookup table */
    field_ids: string[];
};
export type FormFieldDefinitionSchema = {
    /** Field definition ID */
    id: string;
    /** Field name */
    name: string;
    /** Field description */
    description?: string;
    /** Data type of the field (e.g., text, number, date, select) */
    data_type: string;
    /** Field lookup table reference configured for this field in the workflow */
    field_lookup_table?: FieldLookupTableReferenceSchema | null;
};
export type ConditionReferenceSchema = {
    /** ID of the condition in the condition_library */
    condition_id: string;
};
export type FormQuestionSchema = {
    /** Question ID within the form */
    id: string;
    /** Question display name */
    name: string;
    /** Help text or instructions for the question */
    description?: string;
    /** Whether the question must be answered */
    is_required?: boolean;
    /** Whether the question is read-only (pre-filled) */
    is_read_only?: boolean;
    /** Section name for grouping questions within the form */
    section?: string;
    /** ID of the field in the field_library this question maps to */
    field_id: string;
    /** Inline field definition for this question */
    field_definition: FormFieldDefinitionSchema;
    /** Reference to a condition in the condition_library that controls question visibility */
    visible_condition?: ConditionReferenceSchema | null;
};
export type FormDefinitionSchema = {
    /** Form definition ID */
    id: string;
    /** Form name */
    name: string;
    /** Form description */
    description?: string;
    /** Ordered list of questions in this form */
    questions?: FormQuestionSchema[];
};
export type FormVisibilityEvaluationResult = {
    /** Form definition with conditional visibility applied: hidden questions are omitted */
    form_definition: FormDefinitionSchema;
};
export type FormVisibilityEvaluationResponse = {
    /** Evaluated, visibility-filtered form definition */
    data: FormVisibilityEvaluationResult;
    /** Optional metadata about the evaluation */
    meta?: {
        [key: string]: any;
    } | null;
};
export type FormVisibilityEvaluationAttributes = {
    /** ID of the form to evaluate visibility for */
    form_id: string;
    /** Unsaved field values keyed by field id, used to evaluate visibility conditions in-memory */
    field_values?: {
        [key: string]: any;
    };
};
export type WorkflowFormVisibilityEvaluationRequestData = {
    type: "workflows";
    attributes: FormVisibilityEvaluationAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type WorkflowFormVisibilityEvaluationRequest = {
    data: WorkflowFormVisibilityEvaluationRequestData;
};
export type ActivityLogAttributes = {
    /** ID of the parent resource this log entry belongs to */
    parent_id: string;
    /** Type of the parent resource */
    parent_type: string;
    /** Type of the resource that changed */
    resource_type: string;
    /** ID of the resource that changed */
    resource_id: string;
    /** Action performed on the resource */
    action: string;
    /** ID of the user or system that performed the action */
    actor_id: string;
    /** Type of actor that performed the action */
    actor_type: string;
    /** Structured context for the action; keys depend on the resource_type and action */
    metadata?: {
        [key: string]: any;
    };
    /** When this activity was recorded */
    created_at?: string | null;
};
export type ActivityLogResponseData = {
    type?: "activity-logs";
    id: string;
    attributes: ActivityLogAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListActivityLogsResponse = {
    data: ActivityLogResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type WorkflowTemplateAttributes = {
    /** Display name for the template */
    name: string;
    /** Short description of what the template provides */
    description: string;
    /** Complete workflow definition that can be used as-is when creating a new workflow */
    workflow_definition: {
        [key: string]: any;
    };
};
export type WorkflowTemplateResponseData = {
    type?: "workflow-templates";
    id: string;
    attributes: WorkflowTemplateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListWorkflowTemplatesResponse = {
    data: WorkflowTemplateResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ModelResponseWorkflowTemplateResponseData = {
    data: WorkflowTemplateResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type StageStatus = "pending" | "active" | "completed" | "skipped";
export type TaskSummary = {
    /** Total number of tasks in the stage */
    total: number;
    /** Number of completed/approved tasks */
    completed: number;
    /** Number of pending tasks */
    pending: number;
    /** Number of active (in-progress) tasks */
    active: number;
    /** Number of initialized tasks (stage not yet active) */
    initialized?: number;
};
export type StageAttributes = {
    /** Stage name from the workflow definition */
    name: string;
    /** Stage description */
    description?: string;
    /** Zero-indexed position of this stage in the workflow */
    order: number;
    /** Current stage status */
    status: StageStatus;
    /** Whether this is the currently active stage */
    is_current: boolean;
    /** Whether all blocking conditions are met to exit this stage */
    is_ready_to_complete: boolean;
    /** Human-readable reasons preventing stage completion */
    blocking_reasons?: string[];
    /** When the stage became active */
    entered_at?: string | null;
    /** When the stage was exited */
    exited_at?: string | null;
    /** User ID who triggered the stage transition */
    completed_by?: string | null;
    /** Summary of task counts by status */
    task_summary?: TaskSummary | null;
};
export type StageResponseData = {
    type?: "stages";
    id: string;
    attributes: StageAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListStagesResponse = {
    data: StageResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type StageTransitionResponseAttributes = {
    /** Stage ID of the stage that was exited */
    previous_stage_id: string;
    /** Stage ID of the newly active stage */
    current_stage_id: string;
    /** Updated ticket version after the transition */
    version: number;
};
export type StageTransitionResponseData = {
    type?: "tickets";
    id: string;
    attributes: StageTransitionResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type StageTransitionResponse = {
    data: StageTransitionResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type StageTransitionAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type StageTransitionRequestData = {
    type: "tickets";
    attributes: StageTransitionAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type StageTransitionRequest = {
    data: StageTransitionRequestData;
};
export type Atom = "task_view" | "task_comment" | "task_execute" | "task_assign" | "task_remind" | "task_manage" | "task_claim" | "doc_view" | "doc_comment" | "doc_download" | "doc_upload" | "doc_edit" | "doc_share" | "ticket_view" | "ticket_comment" | "ticket_activity_view" | "ticket_edit" | "ticket_field_edit" | "ticket_pause" | "ticket_stage_transition" | "ticket_delete" | "ticket_cancel" | "ticket_complete" | "grant_view" | "grant_comment" | "grant_edit" | "grant_policy";
export type CustomPolicy = {
    /** Capabilities this ad-hoc policy grants. Mutually exclusive with `bundle_id`. The set identifies the policy, so restating the same atoms edits the existing one rather than creating a second. */
    atoms?: Atom[] | null;
    /** Identifier of a shareable permission policy to grant. Mutually exclusive with `atoms`. A policy owned by a specific ticket or workflow version cannot be referenced this way. */
    bundle_id?: string | null;
    /** Who holds this policy. Entries naming the same policy are merged. */
    principals: AclPrincipal[];
};
export type UpdateSubResourceAclResponseAttributes = {
    /** Effective ACL for the node after the operation. Sub-resource ACL, keyed by permission. Valid keys are `viewer` (read access), `commenter` (read + comment), and `editor` (read + write access); sub-resources have no `owner` tier (sending `owner` is rejected). Each value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. After a PATCH this is the override just set; after a DELETE it is the workflow-definition (or ad-hoc) default the node reverted to (possibly empty, meaning the node inherits access from its parent stage/ticket). Custom policies are reported under `custom`, not here. */
    acl: {
        [key: string]: AclPrincipal[];
    };
    /** Ad-hoc permission policies on the node after the operation. */
    custom?: CustomPolicy[];
    /** Updated ticket version */
    version: number;
};
export type UpdateStageAclResponseData = {
    type?: "tickets";
    id: string;
    attributes: UpdateSubResourceAclResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateStageAclResponse = {
    data: UpdateStageAclResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type UpdateSubResourceAclAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Sub-resource ACL, keyed by permission. Valid keys are `viewer` (read access), `commenter` (read + comment), and `editor` (read + write access); sub-resources have no `owner` tier (sending `owner` is rejected). Each value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. The override REPLACES the node's ACL exactly with this map (it is stored as a per-ticket override; the shared workflow definition is never mutated). An ACL and `custom` that are BOTH empty are rejected with 422 — use DELETE to remove the override and revert to the workflow default. Tiered delegation: you may only grant tiers up to your own access ON THIS NODE (view → viewer; comment → viewer/commenter; edit → any tier); granting a higher tier returns 403. */
    acl?: {
        [key: string]: AclPrincipal[];
    };
    /** Ad-hoc permission policies on this node, each granting an arbitrary set of capabilities to specific principals. Each entry states either `atoms` (a policy this node owns) or `bundle_id` (a shareable one it only references) — never both. Like `acl`, this REPLACES the node's custom policies entirely — omit it (or send `[]`) to leave the node with none. Writing it requires `edit` ON THIS NODE, since a policy names an arbitrary atom set that no tier contains. Removing the override deletes the policies this node owns; a referenced shareable policy survives it and merely loses this node's reference. */
    custom?: CustomPolicy[];
};
export type UpdateStageAclRequestData = {
    type?: "stages";
    attributes: UpdateSubResourceAclAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateStageAclRequest = {
    data: UpdateStageAclRequestData;
};
export type TaskType = "review" | "sign" | "form" | "signer-collection" | "task_group";
export type TaskStatus = "initialized" | "pending" | "active" | "completed" | "approved" | "rejected";
export type RedactedTaskAttributes = {
    /** Discriminator: 'redacted' — the caller may not view this task; contents withheld. */
    visibility?: "redacted";
    /** Kind of task (review, sign, form, task_group) */
    type: TaskType;
    /** Current task lifecycle state */
    status: TaskStatus;
    /** Whether this task was added at runtime (not defined in workflow) */
    is_ad_hoc: boolean;
    /** ID of the stage this task belongs to */
    stage_id?: string | null;
    /** ID of the parent task_group this task belongs to, if any */
    parent_task_id?: string | null;
};
export type AssignmentMode = "specific_user" | "group_all" | "group_any" | "round_robin" | "group_random";
export type JudgmentIntent = "positive" | "negative";
export type TaskAction = {
    /** Unique identifier for this action within the task */
    action_id: string;
    /** Human-readable label for the action (e.g., 'Approve', 'Reject') */
    label: string;
    /** Semantic intent of this action (positive or negative) */
    intent: JudgmentIntent;
};
export type JudgmentSchema = {
    /** Internal user ID who issued this judgment */
    user_id?: string | null;
    /** External user ID who issued this judgment (mutually exclusive with user_id) */
    external_user_id?: string | null;
    /** ID of the action taken (matches an allowed_actions entry) */
    action_id: string;
    /** Semantic intent of the judgment (positive or negative) */
    intent: JudgmentIntent;
    /** Timestamp when the judgment was recorded */
    judged_at: string;
};
export type TaskAssociationType = "field" | "document" | "clause";
export type TaskAssociation = {
    /** Type of artifact this association links to */
    type: TaskAssociationType;
    /** Artifact identifier (field_id, document_id, or Pilot occurrence_id for clause). */
    id: string;
    /** Secondary qualifier. Opaque dict passed through verbatim; the UI determines its structure. */
    context?: {
        [key: string]: any;
    } | null;
};
export type TaskAttributes = {
    /** Discriminator: 'visible' — the caller may view this task's contents. */
    visibility?: "visible";
    /** Task name from the workflow definition */
    name: string;
    /** Kind of task (review, sign, form, task_group) */
    type: TaskType;
    /** Current task lifecycle state */
    status: TaskStatus;
    /** Whether this task was added at runtime (not defined in workflow) */
    is_ad_hoc: boolean;
    /** Internal user IDs assigned to this task */
    assigned_to: string[];
    /** External user IDs assigned to this task */
    assigned_external_users?: string[];
    /** How the task is assigned to users */
    assignment_mode: AssignmentMode;
    /** Actions available for completing this task (e.g., approve, reject) */
    allowed_actions: TaskAction[];
    /** Judgments recorded on this task */
    judgments?: JudgmentSchema[];
    /** Number of approvals required. When null, all assignees must approve. */
    required_approvals?: number | null;
    /** GROUP_RANDOM only: number of users selected from the combined actor pool. */
    assignee_count?: number | null;
    /** Current number of positive judgments */
    approval_count?: number;
    /** Task due date (informational) */
    due_at?: string | null;
    /** Task description or instructions */
    description?: string | null;
    /** ID of the stage this task belongs to */
    stage_id?: string | null;
    /** ID of the parent task_group this task belongs to, if any */
    parent_task_id?: string | null;
    /** Form definition ID for FORM-type tasks */
    form_id?: string | null;
    /** Full form definition for FORM-type tasks; null for other task types */
    form_definition?: FormDefinitionSchema | null;
    /** Linked artifacts (fields, documents, clauses) */
    associations?: TaskAssociation[];
    /** When this ad-hoc task was added (null for workflow-defined tasks) */
    added_at?: string | null;
    /** User ID of who added this ad-hoc task (null for workflow-defined tasks) */
    added_by?: string | null;
};
export type TaskResponseData = {
    type?: "tasks";
    id: string;
    attributes: ({
        visibility: "redacted";
    } & RedactedTaskAttributes) | ({
        visibility: "visible";
    } & TaskAttributes);
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListTasksResponse = {
    data: TaskResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type GetTaskResponse = {
    data: TaskResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ResourceDescription = string;
export type ActorType = "User" | "Department" | "Role" | "ExternalUser" | "PreviousTaskCompleter";
export type ActorSchema = {
    /** Type of actor (User, Department, Role, etc.) */
    actor_type: ActorType;
    /** Identifier for the actor (user_id, department_id, role_uuid, etc.) */
    actor_id: string;
};
export type AdHocTaskCreateAttributes = {
    /** Current TICKET version for optimistic locking (the ad-hoc task is a mutation on the ticket and is validated against the ticket's version). */
    version: VersionInt;
    /** Stage ID from the workflow definition where this ad-hoc task will be added. Use current_stage_id from the ticket or list stages via GET /tickets/{id}/stages. */
    parent_stage_id: string;
    /** Parent task_group ID if creating a child task */
    parent_task_id?: string | null;
    /** Display name for the ad-hoc task */
    name: ResourceName;
    /** Kind of task to create (review, sign, form, task_group) */
    type: TaskType;
    /** Optional sub-resource ACL for the new ad-hoc task, keyed by permission (`viewer` / `commenter` / `editor`; sub-resources have no `owner` tier — sending `owner` is rejected). Each value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. When set, the task's ACL is materialized to SpiceDB on creation; omit or send `{}` to inherit access from the parent stage/ticket. You may only grant a tier you hold on the ticket. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Form ID; required when type is FORM */
    form_id?: string | null;
    /** How the task should be assigned */
    assignment_mode: AssignmentMode;
    /** Actions available for completing this task. NOTE: ad-hoc task allowed_actions use field name `action_id` for the action identifier (e.g. `{"action_id":"approve","label":"Approve","intent":"positive"}`). This differs from the workflow_definition's stages[].tasks[].allowed_actions, which uses `id`. */
    allowed_actions: TaskAction[];
    /** Optional due date for the task */
    due_at?: string | null;
    /** Optional task description or instructions */
    description?: ResourceDescription | null;
    /** List of task IDs that must complete before this task can start. If left empty, this defaults to the incomplete tail of any sequential dependency chain already present in the task's stage or task_group. */
    depends_on?: string[];
    /** Number of approvals required. When null, all assignees must approve. */
    required_approvals?: number | null;
    /** GROUP_RANDOM only: number of users to select from the combined actor pool. */
    assignee_count?: number | null;
    /** Actor definitions for task assignment. Each actor specifies a user, department, role, external user, or previous task completer. Resolved at creation time (except PreviousTaskCompleter, which resolves when the dependency completes). */
    actors: ActorSchema[];
    /** Artifacts to link to the task (fields, documents, clauses) */
    associations?: TaskAssociation[];
};
export type AdHocTaskCreateRequestData = {
    type: "tasks";
    attributes: AdHocTaskCreateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type AdHocTaskCreateRequest = {
    data: AdHocTaskCreateRequestData;
};
export type AdHocTaskUpdateAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** New task name. Omit to leave unchanged. */
    name?: ResourceName | null;
    /** New due date. Omit to leave unchanged. Pass null to clear. */
    due_at?: string | null;
    /** New description. Omit to leave unchanged. Pass null to clear. */
    description?: ResourceDescription | null;
};
export type AdHocTaskUpdateRequestData = {
    type: "tasks";
    attributes: AdHocTaskUpdateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type AdHocTaskUpdateRequest = {
    data: AdHocTaskUpdateRequestData;
};
export type TaskCompleteResponseAttributes = {
    /** New task status after completion */
    status: string;
    /** When the judgment was recorded */
    judged_at: string;
    /** Total number of positive judgments after this completion */
    approval_count: number;
    /** Number of approvals needed for the task to be fully approved */
    required_approvals: number;
    /** IDs of tasks that were activated as a result of this completion */
    next_tasks_activated?: string[];
};
export type TaskCompleteResponseData = {
    type?: "tasks";
    id: string;
    attributes: TaskCompleteResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TaskCompleteResponse = {
    data: TaskCompleteResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type TaskCompleteAttributes = {
    /** Current TICKET version for optimistic locking. Task lifecycle endpoints (complete/claim/reset/retract/assign) validate against the parent ticket's version — not the task's. Re-GET the ticket after any prior mutation to obtain the correct value. */
    version: VersionInt;
    /** ID of the action to perform (must match one of the task's allowed_actions) */
    action_id: string;
    /** Optional parameters for the action (e.g., form responses for FORM tasks) */
    action_params?: {
        [key: string]: any;
    };
};
export type TaskCompleteRequestData = {
    type: "tasks";
    attributes: TaskCompleteAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TaskCompleteRequest = {
    data: TaskCompleteRequestData;
};
export type TaskAssignAttributes = {
    /** Current TICKET version for optimistic locking. Task lifecycle endpoints validate against the parent ticket's version — not the task's. Re-GET the ticket after any prior mutation to obtain the correct value. */
    version: VersionInt;
    /** Internal user IDs to assign to the task */
    user_ids?: string[];
    /** External user IDs (must exist in ticket.external_users) */
    external_user_ids?: string[];
};
export type TaskAssignRequestData = {
    type: "tasks";
    attributes: TaskAssignAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TaskAssignRequest = {
    data: TaskAssignRequestData;
};
export type TaskClaimAttributes = {
    /** Current TICKET version for optimistic locking. Task lifecycle endpoints validate against the parent ticket's version — not the task's. */
    version: VersionInt;
};
export type TaskClaimRequestData = {
    type: "tasks";
    attributes: TaskClaimAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TaskClaimRequest = {
    data: TaskClaimRequestData;
};
export type TaskResetAttributes = {
    /** Current TICKET version for optimistic locking. Also used by /retract. Task lifecycle endpoints validate against the parent ticket's version — not the task's. */
    version: VersionInt;
};
export type TaskResetRequestData = {
    type: "tasks";
    attributes: TaskResetAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TaskResetRequest = {
    data: TaskResetRequestData;
};
export type TaskAssociationUpdateAttributes = {
    /** Current TICKET version for optimistic locking (task associations are a mutation on the ticket and are validated against the ticket's version). */
    version: VersionInt;
    /** Full replacement list of task associations (fields, documents, clauses) */
    associations?: TaskAssociation[];
};
export type TaskAssociationUpdateRequestData = {
    type: "tasks";
    attributes: TaskAssociationUpdateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TaskAssociationUpdateRequest = {
    data: TaskAssociationUpdateRequestData;
};
export type UpdateTaskAclResponseData = {
    type?: "tickets";
    id: string;
    attributes: UpdateSubResourceAclResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateTaskAclResponse = {
    data: UpdateTaskAclResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type UpdateTaskAclRequestData = {
    type?: "tasks";
    attributes: UpdateSubResourceAclAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateTaskAclRequest = {
    data: UpdateTaskAclRequestData;
};
export type EmptyResponse = {
    data?: {
        [key: string]: any;
    };
};
export type FieldRawValue = string | boolean | any[] | {
    [key: string]: any;
};
export type FieldOrigin = "api" | "ai" | "manual";
export type FieldValueSchema = {
    /** Raw field value as stored in Postgres. Scalar for single-value fields; list for multi-value; dict for monetary. */
    value: FieldRawValue;
    /** When this field was last updated */
    updated_at: string;
    /** User ID who last updated this field */
    updated_by: string;
    /** How the value was set (manual, ai_extracted, system, etc.) */
    origin?: FieldOrigin;
};
export type FieldUpdateResponseAttributes = {
    /** Updated ticket version after the field update */
    version: number;
    /** Map of all field values on the ticket keyed by field_id from the workflow definition. */
    field_values: {
        [key: string]: FieldValueSchema;
    };
};
export type FieldUpdateResponseData = {
    type?: "tickets";
    id: string;
    attributes: FieldUpdateResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type FieldUpdateResponse = {
    data: FieldUpdateResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type FieldValueScalarEntry = {
    /** Scalar field value: a string for TEXT/DATE/NUMBER fields, or a boolean for BOOLEAN fields */
    value: string | boolean;
};
export type FieldValueMonetaryEntry = {
    /** Monetary amount as a decimal string */
    amount: string;
    /** ISO 4217 currency code */
    currency: string;
};
export type FieldValueFileEntry = {
    /** File attachment identifier */
    id: string;
    /** Filename of the attachment */
    name: string;
    /** File extension */
    file_type: string;
};
export type FieldValueReferenceEntry = {
    /** Workday resource identifier (WID) */
    resource_id: string;
    /** Human-readable display name for the reference */
    default_value: string;
};
export type FieldValueDurationEntry = {
    /** Positive integer count of periods */
    amount: number;
    /** Calendar unit for the duration */
    period: "day" | "week" | "month" | "quarter" | "year";
};
export type FieldValueAddressEntry = {
    /** Street-level address lines; at least one is required */
    address_lines: string[];
    /** City or locality */
    locality?: string | null;
    /** State, province, or region */
    administrative_area?: string | null;
    /** Postal or ZIP code */
    postal_code?: string | null;
    /** Country or region code */
    country?: string | null;
};
export type FieldValueUrlEntry = {
    /** The URL string */
    value: string;
    /** Optional display text for the URL */
    label?: string | null;
};
export type FieldValueEntry = FieldValueScalarEntry | FieldValueMonetaryEntry | FieldValueFileEntry | FieldValueReferenceEntry | FieldValueDurationEntry | FieldValueAddressEntry | FieldValueUrlEntry;
export type FieldUpdateAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** New field value as a uniform array of entries (e.g. [{"value": "english"}]); an empty array clears the field. */
    value: FieldValueEntry[];
};
export type FieldUpdateRequestData = {
    type: "fields";
    attributes: FieldUpdateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type FieldUpdateRequest = {
    data: FieldUpdateRequestData;
};
export type FieldBatchUpdateAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Map of field updates keyed by Unified Fields field_id (UUID). Each value is a uniform array of entries; an empty array clears the field. */
    updates: {
        [key: string]: FieldValueEntry[];
    };
};
export type FieldBatchUpdateRequestData = {
    type: "fields";
    attributes: FieldBatchUpdateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type FieldBatchUpdateRequest = {
    data: FieldBatchUpdateRequestData;
};
export type CommentAttributes = {
    /** User ID who authored the comment */
    author_id: string;
    /** Comment body text */
    content: string;
    /** User IDs mentioned in this comment */
    mentions: string[];
    /** Task ID this comment is attached to; null for ticket-level comments */
    task_id: string | null;
    /** Parent comment ID; null for top-level comments */
    parent_id: string | null;
    /** When the comment was created */
    created_at: string | null;
    /** When the comment was last edited; null if never edited */
    updated_at: string | null;
    /** When the comment thread was resolved; null if still open */
    resolved_at: string | null;
};
export type CommentResponseData = {
    type?: "comments";
    id: string;
    attributes: CommentAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CommentResponse = {
    data: CommentResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type CreateCommentAttributes = {
    /** Comment body text (HTML tags are rejected) */
    content: string;
    /** Task ID to attach this comment to; null for ticket-level comments */
    task_id?: string | null;
    /** Parent comment ID for threading; null for top-level comments */
    parent_id?: UuidStr | null;
    /** User IDs mentioned in the comment (rendered as @-mentions in the UI) */
    mentions?: string[];
};
export type CreateCommentRequestData = {
    type?: "comments";
    attributes: CreateCommentAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CreateCommentRequest = {
    data: CreateCommentRequestData;
};
export type ListCommentsResponse = {
    data: CommentResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ThreadAttributes = {
    /** User ID who authored the root comment */
    author_id: string;
    /** Root comment body text */
    content: string;
    /** User IDs mentioned in the root comment */
    mentions: string[];
    /** Task ID this thread is attached to; null for ticket-level threads */
    task_id: string | null;
    /** When the root comment was created */
    created_at: string | null;
    /** When the root comment was last edited; null if never edited */
    updated_at: string | null;
    /** When the thread was resolved; null if still open */
    resolved_at: string | null;
    /** Direct replies to this comment, ordered by created_at ascending. Each reply is a full resource object (with its own id) so clients can target it for edit/delete. */
    replies: CommentResponseData[];
};
export type ThreadResponseData = {
    type?: "comment-threads";
    id: string;
    attributes: ThreadAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListThreadsResponse = {
    data: ThreadResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type UpdateCommentAttributes = {
    /** Updated comment body text (HTML tags are rejected) */
    content: string;
    /** Updated list of mentioned user IDs; replaces the previous mentions list */
    mentions?: string[];
};
export type UpdateCommentRequestData = {
    type?: "comments";
    attributes: UpdateCommentAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateCommentRequest = {
    data: UpdateCommentRequestData;
};
export type DocumentForceUnlockResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Unique identifier for this document */
    document_id: string;
    /** Ticket version after the operation */
    version: number;
    /** The document's per-document optimistic-concurrency token. */
    document_lock_version: number;
    /** Lock metadata after the operation (defaults when unlocked) */
    locking_metadata: DocumentLockingMetadataSchema;
};
export type DocumentForceUnlockResponseData = {
    type?: "documents";
    id: string;
    attributes: DocumentForceUnlockResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentForceUnlockResponse = {
    data: DocumentForceUnlockResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type DocumentForceUnlockRequestAttributes = {
    /** Expected ticket version for optimistic locking. Optional when a per-document lock token is supplied; at least one of the two is required to unlock. */
    version?: VersionInt | null;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    document_lock_version?: number | null;
};
export type DocumentForceUnlockRequestData = {
    type?: "documents";
    attributes: DocumentForceUnlockRequestAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentForceUnlockRequest = {
    data: DocumentForceUnlockRequestData;
};
export type DocumentVersionUpResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** Unique identifier for this document */
    document_id: string;
    /** Ticket version after the operation (unchanged by document writes) */
    version: number;
    /** The document's per-document optimistic-concurrency token. */
    document_lock_version: number;
};
export type DocumentVersionUpResponseData = {
    type?: "documents";
    id: string;
    attributes: DocumentVersionUpResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentVersionUpResponse = {
    data: DocumentVersionUpResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type DocumentVersionUpAttributes = {
    /** Current ticket version for optimistic locking */
    version: VersionInt;
    /** Per-document optimistic-concurrency token. Rejected with 409 when it no longer matches the document's current document_lock_version. */
    document_lock_version: number;
};
export type DocumentVersionUpRequestData = {
    type?: "documents";
    attributes: DocumentVersionUpAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentVersionUpRequest = {
    data: DocumentVersionUpRequestData;
};
export type DocumentPatchResponseAttributes = {
    /** Persisted filename of the document */
    name: string;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the document */
    content_status: ContentStatus;
    /** Document version tag (1 for new, N+1 for re-upload) */
    document_version: number;
    /** All document versions with their metadata, ascending by ``version`` (oldest first, latest last). */
    version_history?: DocumentVersionMetaSchema[];
    /** ID of the patched document */
    document_id: string;
    /** Ticket version after the patch */
    version: number;
    /** The document's per-document optimistic-concurrency token. */
    document_lock_version: number;
};
export type DocumentPatchResponseData = {
    type?: "documents";
    id: string;
    attributes: DocumentPatchResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentPatchResponse = {
    data: DocumentPatchResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type DocumentPatchAttributes = {
    /** Current ticket version for optimistic locking */
    version: VersionInt;
    /** Optional per-document optimistic-concurrency token. When provided, the request is rejected with 409 if it no longer matches the document's current document_lock_version; omit it to skip the per-document check (ticket-version OCC still applies). */
    document_lock_version?: number | null;
    /** Target document type. Must be ATTACHMENT or one of the signable main types (CONTRACT, EXHIBIT, REDLINE, NDA). TEMPLATE is not assignable here. */
    document_type?: DocumentType | null;
    /** New display filename (max 256 chars; a forward slash '/' is not allowed). */
    name?: string | null;
};
export type DocumentPatchRequestData = {
    type: "documents";
    attributes: DocumentPatchAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentPatchRequest = {
    data: DocumentPatchRequestData;
};
export type DocumentSignerSchema = {
    participant_id: string | null;
    signing_slot: number;
    anchor_tag_values?: {
        [key: string]: any;
    };
    signed_at?: string | null;
};
export type RecordSignaturesResponseAttributes = {
    version: number;
    document_id: string;
    signers: DocumentSignerSchema[];
};
export type RecordSignaturesResponseData = {
    type?: "sign-tasks";
    id: string;
    attributes: RecordSignaturesResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type RecordSignaturesResponse = {
    data: RecordSignaturesResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type SignedParticipantItem = {
    participant_id: string;
};
export type SigningParticipantWriteSchema = {
    participant_id: string;
    name?: string | null;
    email?: string | null;
    order: number;
    pilot_user_id?: number | null;
    field_values?: {
        [key: string]: string;
    };
    label?: string | null;
    party?: ("N/A" | "Internal" | "External") | null;
};
export type DocumentSignerWriteSchema = {
    participant_id: string;
    /** Stable label for a signing position in the document — slot 1 is always slot 1 regardless of who is assigned. */
    signing_slot?: number;
};
export type RecordSignaturesAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** ID of the document whose signers are being recorded */
    document_id: string;
    /** Participants whose signed_at timestamp should be set for this document */
    signed_participants: SignedParticipantItem[];
    /** Optional full replace of the signer-collection participant registry. Must be supplied together with document_assignments. Same full-replace payload rules as PUT /tickets/{id}/signing-participants/{task_id}; does not require the signer-collection task to be open (resolved via this sign task). */
    participants?: SigningParticipantWriteSchema[] | null;
    /** Optional full replace of per-document signer slot assignments. Must be supplied together with participants. */
    document_assignments?: {
        [key: string]: DocumentSignerWriteSchema[];
    } | null;
};
export type RecordSignaturesRequestData = {
    type: "sign-tasks";
    attributes: RecordSignaturesAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type RecordSignaturesRequest = {
    data: RecordSignaturesRequestData;
};
export type DocumentSignaturesResult = {
    document_id: string;
    signers: DocumentSignerSchema[];
};
export type RecordSignaturesBatchResponseAttributes = {
    version: number;
    documents: DocumentSignaturesResult[];
};
export type RecordSignaturesBatchResponseData = {
    type?: "sign-tasks";
    id: string;
    attributes: RecordSignaturesBatchResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type RecordSignaturesBatchResponse = {
    data: RecordSignaturesBatchResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type DocumentSignatureItem = {
    /** ID of the document whose signers are being recorded */
    document_id: string;
    /** Participants whose signed_at timestamp should be set for this document */
    signed_participants: SignedParticipantItem[];
};
export type RecordSignaturesBatchAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Documents and their signed participants to record in a single atomic operation */
    documents: DocumentSignatureItem[];
    /** Optional full replace of the signer-collection participant registry. Must be supplied together with document_assignments. Same full-replace payload rules as PUT /tickets/{id}/signing-participants/{task_id}; does not require the signer-collection task to be open (resolved via this sign task). */
    participants?: SigningParticipantWriteSchema[] | null;
    /** Optional full replace of per-document signer slot assignments. Must be supplied together with participants. */
    document_assignments?: {
        [key: string]: DocumentSignerWriteSchema[];
    } | null;
};
export type RecordSignaturesBatchRequestData = {
    type: "sign-tasks";
    attributes: RecordSignaturesBatchAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type RecordSignaturesBatchRequest = {
    data: RecordSignaturesBatchRequestData;
};
export type SigningParticipantSchema = {
    participant_id: string;
    name?: string | null;
    email?: string | null;
    order: number;
    pilot_user_id?: number | null;
    field_values?: {
        [key: string]: string;
    };
    optional_field_names?: string[];
    label?: string | null;
    party?: ("N/A" | "Internal" | "External") | null;
};
export type SigningConfigurationResponseAttributes = {
    version: number;
    participants: SigningParticipantSchema[];
    document_assignments: {
        [key: string]: DocumentSignerSchema[];
    };
};
export type SigningConfigurationResponseData = {
    type?: "signing-participants";
    id: string;
    attributes: SigningConfigurationResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type SigningConfigurationResponse = {
    data: SigningConfigurationResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type SigningConfigurationAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    participants: SigningParticipantWriteSchema[];
    /** Map of document_id to ordered list of slot assignments for that document. */
    document_assignments?: {
        [key: string]: DocumentSignerWriteSchema[];
    };
};
export type SigningConfigurationRequestData = {
    type: "signing-participants";
    attributes: SigningConfigurationAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type SigningConfigurationRequest = {
    data: SigningConfigurationRequestData;
};
export type CreateEsignPackageAcceptedAttributes = {
    /** Sign task id for this enqueue. */
    task_id: string;
};
export type CreateEsignPackageAcceptedResponseData = {
    type?: "esign-packages";
    id: string;
    attributes: CreateEsignPackageAcceptedAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CreateEsignPackageAcceptedResponse = {
    data: CreateEsignPackageAcceptedResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type EsignVendor = "DOCUSIGN" | "ADOBESIGN";
export type CreateEsignPackageAttributes = {
    /** Sign task id on the current stage (must depend on exactly one signer-collection task). */
    task_id: string;
    /** URL where the vendor redirects the user after completing the signing ceremony. */
    return_url: string;
    /** E-signature vendor (DOCUSIGN or ADOBESIGN). */
    vendor: EsignVendor;
    /** Package name; defaults to the ticket name if omitted. */
    package_name?: string | null;
};
export type CreateEsignPackageRequestData = {
    type: "esign-packages";
    attributes: CreateEsignPackageAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CreateEsignPackageRequest = {
    data: CreateEsignPackageRequestData;
};
export type BlockedReason = {
    /** Stable machine-readable reason code. */
    code: string;
    /** Localized human-readable explanation of why the action is blocked. */
    message: string;
    /** Structured detail for the code (e.g. blocking_task_ids, missing_field_ids); {} when none. */
    meta?: {
        [key: string]: any;
    };
};
export type ActionInvoke = {
    /** HTTP method of the route that performs this action. */
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
    /** Path of the route that performs this action, e.g. /tickets/{id}/tasks/{task_id}/complete. */
    path: string;
};
export type ActionEntry = {
    /** Action identifier. For task_lifecycle this is the workflow action_id accepted verbatim by the complete route as the action_id body field. */
    id: string;
    /** The kind of action, grouping it by the surface it acts on. */
    kind: "ticket_lifecycle" | "task_lifecycle" | "task_assignment" | "sign_operation" | "document_operation" | "field_operation" | "metadata_operation" | "comment_operation" | "stage_lifecycle";
    /** True iff the action can be performed now (blocked_reason is null). */
    available: boolean;
    /** Why the action is unavailable; null iff available is true. */
    blocked_reason?: BlockedReason | null;
    /** Non-blocking advisory when the action is available (e.g. side-effect warning). Null when unavailable or when no advisory applies. */
    notice?: BlockedReason | null;
    /** The HTTP method and path used to perform this action. Required whenever a K2 route performs the action; null only when no such route exists (e.g. edit_document, where Scribyl — not K2 — opens and holds the collaborative-edit session). */
    invoke?: ActionInvoke | null;
    /** Display label for renderable workflow actions (task_lifecycle only). */
    label?: string | null;
    /** Visual intent for renderable workflow actions (task_lifecycle only); matches JudgmentIntent. */
    intent?: ("positive" | "negative") | null;
};
export type AclPermission = "viewer" | "commenter" | "editor";
export type TicketActionsNodeTicket = {
    /** Ticket-level actions: lifecycle (pause/resume/cancel/complete), add_document, update_fields, and rename. */
    actions: ActionEntry[];
    /** True iff the caller may comment on the ticket (SpiceDB `comment` permission; editor/owner imply comment). */
    can_comment?: boolean;
    /** ACL tiers the caller may grant on this ticket via the ACL endpoint (tiered delegation), resolved from the schema's `can_grant_viewer`/`can_grant_commenter`/`can_grant_editor`: a tier is listed when the caller holds that tier's grant right, and holding the tier's other permissions is neither required nor sufficient. A viewer may grant `viewer`, a commenter `viewer`+`commenter` and an editor all three, so the tiers are cumulative for tier grantees; a custom permission set is resolved right by right and may produce any subset, including a non-contiguous one. Treat this as an opaque set rather than a ladder. Owner is never grantable here (set via owner-reassignment). */
    grantable_acl_tiers?: AclPermission[];
};
export type AssigneeActionMetadata = {
    /** Internal user ID; null for external users. */
    user_id?: string | null;
    /** External user ID; null for internal users. */
    external_user_id?: string | null;
    /** True iff this assignee's slot can be reassigned via PATCH /assign. */
    can_assign: boolean;
    /** True iff this assignee has a recorded judgment that can be cleared. */
    can_reset: boolean;
};
export type TaskActionsNode = {
    /** The task's type (review, sign, signer-collection, form, task_group). */
    task_type: string;
    /** True iff the caller's user id is among the task's assignees. Assignment gates the task's approve/reject JUDGMENT (the `complete` action) ONLY for a task that has actors configured OR current assignees: any caller who is not an assignee of such a task -- a Full Admin included -- sees the judgment as unavailable (`blocked_reason=not_assignee`) and `POST /complete` returns 403 (EKP-56581). A task authored with NO actors and no current assignees (e.g. Sign, Signer-Collection, or a Form left unassigned) is exempt from this gate -- any caller with edit may execute its judgment -- until someone assigns it (EKP-57022). Assignment does not affect the other task actions (assign/claim/reset), which remain gated on edit only. */
    assigned_to_caller: boolean;
    /** True iff the caller may add or change assignees on this task. False when the task is in a terminal status (completed/approved/rejected), the ticket is not active, or the caller lacks edit permission. Derived from the availability of the 'reassign' action. */
    can_assign: boolean;
    /** True iff the caller may execute a judgment on this task AND at least one workflow judgment action (approve/reject/sign/etc.) is currently available. 'May execute' means the caller is an assignee of an assignable task -- assignment is required and is NOT bypassed for Full Admins (EKP-56581) -- OR the task has neither actors configured nor current assignees (EKP-57022). Meta-operations like 'reset' and 'claim' are excluded. Use this to gate the 'execute action' UI affordance. */
    can_execute_action: boolean;
    /** Actions available on this task (keyed list, not a map). */
    actions: ActionEntry[];
    /** Per-assignee action metadata. One entry per internal or external assignee. */
    assignee_metadata?: AssigneeActionMetadata[];
};
export type DocumentActionsNode = {
    /** The document's type (e.g. CONTRACT, ATTACHMENT, NDA). */
    document_type: string;
    /** Whether this document's type is in the K2 signable allowlist (contract, exhibit, redline, nda). Sourced from the backend allowlist so callers do not infer signability from document type. */
    is_signable: boolean;
    /** Why the document is not signable; null iff is_signable is true. */
    not_signable_reason?: BlockedReason | null;
    /** Why this document would not be updated by the async field/signing regen planner if it ran now; null when the document is GENERATED and eligible for regen. Reflects an active signing package (checked ticket-wide) or a per-document condition (manually replaced/UPLOADED source, collaborative edit lock, or otherwise ineligible -- e.g. SIGNED). Mirrors task_blocking.document_regen_skip_reason / plan_fills semantics. */
    regen_skip_reason?: BlockedReason | null;
    /** Document operations: upload_new_version, version_up, rename_document, change_document_type, delete_document, force_unlock, edit_document, and share. */
    actions: ActionEntry[];
};
export type StageActionsNode = {
    /** Current stage status (pending, active, completed, skipped). */
    status: StageStatus;
    /** Whether this is the ticket's currently active stage. */
    is_current: boolean;
    /** Zero-indexed position among the included stages (visible plus backward-reachable). */
    order: number;
    /** Stage operations: complete_stage, reset_stage, transition_to_stage, and add_task (each emitted only when applicable to this stage's status/position). */
    actions: ActionEntry[];
};
export type CommentActionsNode = {
    /** Task scope when the comment is task-scoped; null for ticket-level comments. */
    task_id?: string | null;
    /** True when the comment is a root thread (parent_id is null). */
    is_root: boolean;
    /** Per-comment operations: edit_comment, delete_comment, reply_comment, resolve_comment, and unresolve_comment. */
    actions: ActionEntry[];
};
export type NodeAclActions = {
    /** True iff the caller may view this node. */
    can_view: boolean;
    /** True iff the caller may comment on this node. */
    can_comment: boolean;
    /** True iff the caller may edit this node. */
    can_edit: boolean;
    /** ACL tiers the caller may grant on this node — the same `can_grant_*` question the ticket answers, asked of the node's own SpiceDB object: a tier is listed when the caller holds that tier's grant right ON THIS NODE (inherited from the parent ticket/stage if not granted directly). Like the ticket-level set, treat it as an opaque set rather than a ladder. */
    grantable_acl_tiers?: AclPermission[];
};
export type TicketActionsAttributes = {
    /** Ticket-level action availability. */
    ticket: TicketActionsNodeTicket;
    /** Per-task action availability keyed by task_id (not an array); only visible tasks are included. */
    tasks: {
        [key: string]: TaskActionsNode;
    };
    /** Per-document action availability keyed by document_id (not an array). */
    documents: {
        [key: string]: DocumentActionsNode;
    };
    /** Per-stage action availability keyed by stage_id (not an array). Includes visible stages plus completed stages that remain backward-reachable for reopening. Stages the caller may not view (sub-resource ACL denial) are returned as redacted shells — structural status/is_current/order retained, no actions — mirroring the GET read-shape. */
    stages: {
        [key: string]: StageActionsNode;
    };
    /** Per-comment action availability keyed by comment_id (not an array). Includes only live (non-deleted) comments on visible, non-redacted tasks plus ticket-level comments. ``create_comment`` lives on the ticket/task nodes. */
    comments?: {
        [key: string]: CommentActionsNode;
    };
    /** Per-node sub-resource ACL capabilities keyed by stage_id/task_id (not an array). Contains ONLY ACL-controlled nodes; a node absent from this map is un-ACL'd and inherits the ticket-level capabilities (fall back to the ticket node, do not assume denial). {} when the ticket has no sub-resource grants. */
    node_permissions?: {
        [key: string]: NodeAclActions;
    };
};
export type TicketActionsResponseData = {
    type?: "ticket-actions";
    id: string;
    attributes: TicketActionsAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type GetTicketActionsResponse = {
    data: TicketActionsResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type TicketMode = "live" | "sandbox";
export type TicketState = "ACTIVE" | "PAUSED" | "CANCELLED" | "COMPLETED";
export type TicketIntegrationSchema = {
    /** Configured ticket integration type */
    integration_type: IntegrationType;
    /** Workflow-side reference identifier */
    wss_reference_id?: string | null;
    /** External contract record identifier */
    contract_record_unique_id?: string | null;
};
export type TicketDocument = {
    /** Unique identifier for this document */
    document_id: string;
    /** Filename of the document */
    name: string;
    /** How the document was added (uploaded, generated, etc.) */
    source: DocumentSource;
    /** Document's role: contract | attachment | template */
    document_type: DocumentType;
    /** Processing status of the current version */
    content_status: ContentStatus;
    /** Storage backend (pilot or muse) */
    storage: DocumentStorage;
    /** Current version number (increments on re-upload) */
    document_version?: number;
    /** Per-document optimistic-concurrency token (distinct from document_version, the content re-upload counter). Optional on writes: when supplied on a document mutation it is enforced with a 409 on mismatch; omit it to fall back to ticket-version OCC. */
    document_lock_version?: number;
    /** Chronological list of all document versions with their metadata */
    version_history?: DocumentVersionMetaSchema[];
    /** Whether the document can be opened in the browser viewer. True when content is ready and either the format has a native viewer (e.g. PDF) or the SFDT conversion for the current version is complete. */
    is_viewable: boolean;
    /** Pilot-internal document identifier */
    pilot_document_id?: string | null;
    /** Pilot FileAttachment identifier. Set after a ticket-completion convert step transforms an ATTACHMENT-typed document into a Pilot FileAttachment. */
    pilot_attachment_id?: string | null;
    /** In-progress upload ID (null once complete) */
    upload_id?: string | null;
    /** Template ID if document was generated from a template */
    template_id?: string | null;
    /** Original template document ID for generated documents */
    source_template_document_id?: string | null;
    /** E-signature lifecycle state */
    signing_status: SigningStatus;
    /** List of signer records for e-signature documents */
    signers?: {
        [key: string]: any;
    }[];
    /** When the document was generated from a template */
    generated_at?: string | null;
    /** Collaborative-edit lock metadata (Scribyl inbound S2S and future callers) */
    locking_metadata?: DocumentLockingMetadataSchema;
    /** Whether the document is the originator's paper (first_party) or the counterparty's paper (third_party). Immutable after attach. */
    paper_type?: PaperType;
    /** Whether a new version of this document can be uploaded. False when the document is signed (signing_status=SIGNED), has an upload in progress (content_status=PENDING), or is a read-only template (document_type=TEMPLATE). */
    is_able_to_upload_new_version: boolean;
};
export type RedactedAdHocTask = {
    /** Discriminator: 'redacted' — the caller may not view this ad-hoc task; contents are withheld. */
    visibility?: "redacted";
    /** Unique identifier for this ad-hoc task */
    task_id: string;
    /** Stage ID where this task was added */
    parent_stage_id: string;
    /** Parent task_group ID if this is a child task */
    parent_task_id?: string | null;
    /** Kind of task (review, sign, form, task_group) */
    type: TaskType;
};
export type AdHocTask = {
    /** Discriminator: 'visible' — the caller may view this ad-hoc task's contents. */
    visibility?: "visible";
    /** Unique identifier for this ad-hoc task */
    task_id: string;
    /** Stage ID where this task was added */
    parent_stage_id: string;
    /** Parent task_group ID if this is a child task */
    parent_task_id?: string | null;
    /** Display name of the task */
    name: string;
    /** Kind of task (review, sign, form, task_group) */
    type: TaskType;
    /** Internal user IDs assigned to this task */
    assigned_to?: string[];
    /** External user IDs assigned to this task */
    assigned_external_users?: string[];
    /** How the task is assigned to users */
    assignment_mode: AssignmentMode;
    /** Actions available for completing this task */
    allowed_actions?: TaskAction[];
    /** Task due date (informational, not enforced) */
    due_at?: string | null;
    /** Optional task description or instructions */
    description?: string | null;
    /** Number of approvals required. When null, all assignees must approve. */
    required_approvals?: number | null;
    /** GROUP_RANDOM only: number of users selected from the combined actor pool. */
    assignee_count?: number | null;
    /** When this ad-hoc task was created */
    added_at: string;
    /** User ID who created this ad-hoc task */
    added_by: string;
};
export type RedactedStageState = {
    /** Discriminator: 'redacted' — the caller may not view this stage; transition details withheld. */
    visibility?: "redacted";
    /** Current stage status (pending, active, completed, skipped) */
    status: StageStatus;
};
export type StageState = {
    /** Discriminator: 'visible' — the caller may view this stage's contents. */
    visibility?: "visible";
    /** Current stage status (pending, active, completed, skipped) */
    status: StageStatus;
    /** When the stage became active */
    entered_at?: string | null;
    /** When the stage was exited (completed or skipped) */
    exited_at?: string | null;
    /** User ID who triggered the stage transition */
    completed_by?: string | null;
};
export type RedactedTaskState = {
    /** Discriminator: 'redacted' — the caller may not view this task; contents withheld. */
    visibility?: "redacted";
    /** Current task status */
    status: TaskStatus;
};
export type TaskState = {
    /** Discriminator: 'visible' — the caller may view this task's contents. */
    visibility?: "visible";
    /** Current task status */
    status: TaskStatus;
    /** Internal user IDs assigned to this task */
    assigned_to?: string[];
    /** External user IDs assigned to this task */
    assigned_external_users?: string[];
    /** When the task transitioned to active */
    started_at?: string | null;
    /** Judgments recorded on this task */
    judgments?: JudgmentSchema[];
};
export type WorkflowEmbedAttributes = {
    /** Workflow name (frozen on the ticket at creation) */
    name: string;
    /** Workflow description */
    description?: string;
    /** Version of the workflow definition frozen on the ticket */
    version: number;
    /** The frozen workflow definition blueprint */
    workflow_definition: WorkflowDefinitionResponse;
};
export type TicketAttributes = {
    /** Ticket name */
    name: string;
    /** Ticket description */
    description?: string;
    /** Execution mode (live or sandbox) */
    mode: TicketMode;
    /** Current lifecycle state */
    state: TicketState;
    /** Stage ID of the currently active stage from the workflow definition */
    current_stage_id: string;
    /** Zero-indexed position of current stage */
    current_stage_order?: number;
    /** Total number of stages in workflow */
    total_stages?: number;
    /** Whether current stage is ready to complete */
    is_ready_to_complete?: boolean;
    /** Number of open leaf tasks (excludes TASK_GROUP containers) */
    open_task_count?: number;
    /** ID of the workflow this ticket was created from */
    workflow_id: string;
    /** Version of the workflow definition used */
    workflow_version: number;
    /** Integration metadata for workflows configured with an external integration. */
    integration?: TicketIntegrationSchema | null;
    /** Absolute URL to this ticket's contract in the WSS portal. Null when the ticket has no WSS integration, has no contract record yet, or the portal address is unavailable — treat null as 'no link available', not an error. */
    wss_contract_url?: string | null;
    /** Optimistic locking version; incremented on every mutation */
    version: number;
    /** Map of field values keyed by field_id from the workflow definition. Included when ?include=field_values is specified. */
    field_values?: {
        [key: string]: FieldValueSchema;
    } | null;
    /** Attached documents. Included when ?include=documents is specified. */
    documents?: TicketDocument[] | null;
    /** User-created ad-hoc tasks. Included when ?include=ad_hoc_tasks is specified. Each entry is discriminated on `visibility`: `visible` carries full contents, `redacted` carries identity only (a sub-resource ACL denial). */
    ad_hoc_tasks?: (({
        visibility: "redacted";
    } & RedactedAdHocTask) | ({
        visibility: "visible";
    } & AdHocTask))[] | null;
    /** Access control list keyed by permission name (`viewer` for read access, `commenter` for read + comment, `editor` for read + write access). Each value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Map of stage states keyed by stage_id from the workflow definition. Included when ?include=stage_states is specified. Each value is discriminated on `visibility`: `visible` carries status + transition details, `redacted` carries status only (a sub-resource ACL denial). */
    stage_states?: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedStageState) | ({
            visibility: "visible";
        } & StageState);
    } | null;
    /** Map of task states keyed by task_id from the workflow definition. Included when ?include=task_states is specified. Each value is discriminated on `visibility`: `visible` carries status + assignees + judgments, `redacted` carries status only (a sub-resource ACL denial). */
    task_states?: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedTaskState) | ({
            visibility: "visible";
        } & TaskState);
    } | null;
    /** E-sign authoring and package status (signer lists per signer-collection task, package status per sign task). Included when ?include=esign_state is specified. */
    esign_state?: {
        [key: string]: any;
    } | null;
    /** Embedded workflow blueprint. Populated only when ?include=workflow is specified (opt-in; not part of the default all-fields response). Lets a ticket-authorized caller render the workflow without holding workflow.view. */
    workflow?: WorkflowEmbedAttributes | null;
    /** When the ticket transitioned to COMPLETED state; null until then. */
    completed_at?: string | null;
    /** When the ticket transitioned to CANCELLED state; null until then. */
    cancelled_at?: string | null;
    /** Reason provided when the ticket was cancelled. Populated only on GET /tickets/{id} when state is CANCELLED. */
    cancellation_reason?: string | null;
    /** User ID of the ticket owner (defaults to the creator on create) */
    owner_user_id: string;
    /** When the ticket was created */
    created_at: string;
    /** User ID who created the ticket */
    created_by: string;
    /** When the ticket was last updated */
    updated_at?: string | null;
    /** User ID who last updated the ticket */
    updated_by?: string | null;
};
export type TicketResponseData = {
    type?: "tickets";
    id: string;
    attributes: TicketAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListTicketsResponse = {
    data: TicketResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type TicketIncludeParam = "field_values" | "stage_states" | "task_states" | "documents" | "ad_hoc_tasks" | "acl" | "esign_state" | "workflow";
export type TicketCreateResponseAttributes = {
    /** Ticket name */
    name: string;
    /** Ticket description */
    description?: string;
    /** Execution mode (live or sandbox) */
    mode: TicketMode;
    /** Initial lifecycle state (always ACTIVE) */
    state: TicketState;
    /** Stage ID of the first active stage */
    current_stage_id: string;
    /** ID of the workflow this ticket was created from */
    workflow_id: string;
    /** Version of the workflow definition used */
    workflow_version: number;
    /** Integration metadata for workflows configured with an external integration. */
    integration?: TicketIntegrationSchema | null;
    /** Initial optimistic locking version */
    version: number;
    /** When the ticket was created */
    created_at: string;
    /** User ID who created the ticket */
    created_by: string;
};
export type TicketCreateResponseData = {
    type?: "tickets";
    id: string;
    attributes: TicketCreateResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CreateTicketResponse = {
    data: TicketCreateResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type DocumentSourceChoice = "template" | "upload" | "none";
export type ContractActionType = "renewal" | "amendment" | "termination" | "non-renewal";
export type TicketCreateAttributes = {
    /** Name for the new ticket */
    name: ResourceName;
    /** Execution mode: live (real) or sandbox (test, deletable) */
    mode?: TicketMode;
    /** Pre-populated field values from the intake form, keyed by Unified Fields field_id (UUID). Each value is a uniform array of entries (e.g. [{"value": "english"}]); an empty array means no value. */
    initial_field_values?: {
        [key: string]: FieldValueEntry[];
    };
    /** Template selected by the requester when the intake form uses requester_choice generation. The ID must be present in the form's document_template_ids. */
    template_id?: string | null;
    /** Requester's explicit template-vs-upload choice, for intake forms whose requester_choice generation mode presents both as a real binary choice (EKP-58403). 'upload' or 'none' skips initial document generation entirely, even when the form has configured templates and template_id is omitted. Omitting this field (older/unmigrated FE flows) preserves the prior behavior of generating every configured template when no template_id is given. */
    document_source_choice?: DocumentSourceChoice | null;
    /** Contract actions only: the source contract's Pilot document id. When set, the created ticket is grouped with the source contract in MES. Omit for a normal create. */
    source_document_id?: string | null;
    /** Contract actions only: the action that produced this ticket (e.g. "renewal", "amendment", "termination", "non-renewal"). Recorded on the create activity metadata alongside source_document_id. Serializes as its string value. */
    action_type?: ContractActionType | null;
};
export type TicketCreateRequestData = {
    type: "tickets";
    attributes: TicketCreateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CreateTicketRequest = {
    data: TicketCreateRequestData;
};
export type TicketSearchResultAttributes = {
    /** Name of the ticket */
    ticket_name: string;
    /** Current lifecycle state */
    state: TicketState;
    /** ID of the source workflow */
    workflow_id: string;
    /** Name of the source workflow */
    workflow_name: string;
    /** Name of the current stage */
    current_stage_name: string;
    /** When the current stage was entered */
    current_stage_entered_at?: string | null;
    /** Number of attached documents */
    document_count?: number;
    /** Number of open tasks */
    open_task_count?: number;
    /** User IDs assigned to open tasks */
    assignee_ids?: string[];
    /** Display names of assigned users */
    assignee_names?: string[];
    /** User IDs ever assigned to any visible task (past, present, future) */
    participant_ids?: string[];
    /** Start time of the oldest open task */
    oldest_open_task_started_at?: string | null;
    /** User ID of the ticket owner */
    owner_user_id?: string | null;
    /** Display name of the ticket owner */
    owner_name?: string | null;
    /** User ID who created the ticket */
    created_by: string;
    /** When the ticket was created */
    created_at: string;
    /** When the ticket was last updated */
    updated_at?: string | null;
};
export type TicketSearchResultData = {
    type?: "tickets";
    id: string;
    attributes: TicketSearchResultAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TicketSearchResponse = {
    data: TicketSearchResultData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type SearchDateFilter = {
    /** Exact date match */
    eq?: string | null;
    /** Greater than or equal to date */
    gte?: string | null;
    /** Less than or equal to date */
    lte?: string | null;
    /** Date range as [start, end] tuple */
    between?: string[] | null;
    /** Relative duration filter (e.g., '7d', '2w', '3m', '1y') */
    last?: string | null;
};
export type SearchNumericFilter = {
    /** Exact numeric match */
    eq?: number | null;
    /** Greater than value */
    gt?: number | null;
    /** Greater than or equal to value */
    gte?: number | null;
    /** Less than value */
    lt?: number | null;
    /** Less than or equal to value */
    lte?: number | null;
    /** Numeric range as [min, max] tuple */
    between?: number[] | null;
};
export type SearchDurationFilter = {
    /** Minimum elapsed duration (e.g., '7d', '2w', '3m', '1y') */
    gte?: string | null;
    /** Maximum elapsed duration (e.g., '7d', '2w', '3m', '1y') */
    lte?: string | null;
};
export type FieldValueFilter = {
    /** Ticket field ID (UUID); matches a key in the ticket's field_values */
    field_id: UuidStr;
    /** Accepted values for this field (OR within a field). Omit or leave empty to filter by field presence only (ticket has this field set). A ticket whose field holds a multi-value list matches when any element equals one of these values. */
    values?: (string | number | number | boolean | {
        [key: string]: any;
    })[] | null;
};
export type TicketSearchFilters = {
    /** Filter by ticket state(s) */
    state?: TicketState[] | null;
    /** Filter by workflow name (case-insensitive exact match) */
    workflow_name?: string[] | null;
    /** Filter by workflow ID (exact match) */
    workflow_id?: string[] | null;
    /** Filter by current stage name (case-insensitive exact match) */
    current_stage_name?: string[] | null;
    /** Filter by assigned user IDs (any match) */
    assignee_ids?: string[] | null;
    /** Filter by ticket owner user IDs (exact match against any provided ID) */
    owner_ids?: string[] | null;
    /** Filter by all-time participant user IDs (any match). Matches users ever assigned to any visible task on the ticket regardless of task status, including completed and not-yet-started tasks. Use assignee_ids for currently open tasks only. */
    participant_ids?: string[] | null;
    /** Filter by creator user ID */
    created_by?: string | null;
    /** Filter by creation date */
    created_at?: SearchDateFilter | null;
    /** Filter by last update date */
    updated_at?: SearchDateFilter | null;
    /** Filter by number of attached documents */
    document_count?: SearchNumericFilter | null;
    /** Filter by number of open tasks */
    open_task_count?: SearchNumericFilter | null;
    /** Filter by time spent in current stage (seconds) */
    time_in_stage?: SearchDurationFilter | null;
    /** Filter by duration of longest open task (seconds) */
    time_for_longest_task?: SearchDurationFilter | null;
    /** Filter by ticket field values. Each entry targets one field by ID; entries are ANDed. Provide 'values' for a field id/value match (OR within), or omit them to match tickets that merely have the field set. */
    field_values?: FieldValueFilter[] | null;
};
export type SearchSortParam = {
    /** Field name to sort by */
    field?: "ticket_name" | "workflow_name" | "current_stage_name" | "state" | "created_at" | "updated_at" | "document_count" | "open_task_count" | "time_in_stage" | "time_for_longest_task";
    /** Sort direction: 'asc' or 'desc' */
    direction?: "asc" | "desc";
};
export type SearchPageParam = {
    /** Page number (1-based) */
    number?: number;
    /** Number of results per page (max 100) */
    size?: number;
};
export type TicketSearchRequest = {
    /** Full-text search query across ticket name, workflow name, assignee names, and owner name. A ticket needs to match only some of the query's words, not all of them, to be returned. When set with a multi-word query and `sort` is left on the `created_at` field (the default), results are ordered by `ts_rank_cd` relevance (weighted toward ticket-name matches) instead of recency. Sorting by any other field is always honored as the primary order; relevance only breaks ties between results with an equal sort value in that case. */
    search?: string | null;
    /** Structured filters to narrow results */
    filters?: TicketSearchFilters | null;
    /** Sort specification for results. If left on the `created_at` field (either direction, or omitted entirely) while `search` is a multi-word query, relevance leads instead — see the `search` field. Sorting by any other field always wins as the primary order, even while searching. */
    sort?: SearchSortParam | null;
    /** Pagination parameters */
    page?: SearchPageParam | null;
};
export type TicketCloneAttributes = {
    /** Whether to copy field values from the source ticket */
    copy_field_values?: boolean;
    /** Whether to copy documents from the source ticket */
    copy_documents?: boolean;
};
export type TicketCloneRequestData = {
    type: "tickets";
    attributes: TicketCloneAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CloneTicketRequest = {
    data: TicketCloneRequestData;
};
export type GetTicketResponse = {
    data: TicketResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type TicketUpdateAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** New ticket name. Omit to leave unchanged. */
    name?: ResourceName | null;
    /** New description. Omit to leave unchanged. Pass null to clear. */
    description?: ResourceDescription | null;
};
export type TicketUpdateRequestData = {
    type: "tickets";
    attributes: TicketUpdateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateTicketRequest = {
    data: TicketUpdateRequestData;
};
export type TicketStateAttributes = {
    /** Current lifecycle state of the ticket */
    state: TicketState;
    /** Stage ID of the currently active stage from the workflow definition */
    current_stage_id: string;
    /** Map of stage states keyed by stage_id from the workflow definition (not an array). Keys are stage IDs; values are discriminated on `visibility`: `visible` carries status + timestamps, `redacted` carries status only (a sub-resource ACL denial). */
    stage_states: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedStageState) | ({
            visibility: "visible";
        } & StageState);
    };
    /** Map of visible task states keyed by task_id from the workflow definition (not an array). Keys are task IDs; values are discriminated on `visibility`: `visible` carries status + assignments + judgments, `redacted` carries status only (a sub-resource ACL denial). */
    task_states: {
        [key: string]: ({
            visibility: "redacted";
        } & RedactedTaskState) | ({
            visibility: "visible";
        } & TaskState);
    };
    /** Optimistic locking version */
    version: number;
};
export type TicketStateResponseData = {
    type?: "tickets";
    id: string;
    attributes: TicketStateAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TicketStateResponse = {
    data: TicketStateResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type TicketFormVisibilityEvaluationRequestData = {
    type: "tickets";
    attributes: FormVisibilityEvaluationAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TicketFormVisibilityEvaluationRequest = {
    data: TicketFormVisibilityEvaluationRequestData;
};
export type TicketPauseAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type TicketPauseRequestData = {
    type: "tickets";
    attributes: TicketPauseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type PauseTicketRequest = {
    data: TicketPauseRequestData;
};
export type TicketResumeAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type TicketResumeRequestData = {
    type: "tickets";
    attributes: TicketResumeAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ResumeTicketRequest = {
    data: TicketResumeRequestData;
};
export type TicketCancelAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Reason for cancelling the ticket (stored in activity log) */
    reason: string;
};
export type TicketCancelRequestData = {
    type: "tickets";
    attributes: TicketCancelAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CancelTicketRequest = {
    data: TicketCancelRequestData;
};
export type TicketCompleteAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
};
export type TicketCompleteRequestData = {
    type: "tickets";
    attributes: TicketCompleteAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type CompleteTicketRequest = {
    data: TicketCompleteRequestData;
};
export type ResetStageTasksResponseAttributes = {
    /** IDs of tasks that were reset to PENDING */
    reset_task_ids: string[];
    /** Stage that was reset */
    stage_id: string;
    /** Updated ticket version */
    version: number;
};
export type ResetStageTasksResponseData = {
    type?: "tickets";
    id: string;
    attributes: ResetStageTasksResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ResetStageTasksResponse = {
    data: ResetStageTasksResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ResetStageTasksAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Stage to reset. Defaults to the current stage; must be the current stage when provided. */
    stage_id?: string | null;
};
export type ResetStageTasksRequestData = {
    type: "tickets";
    attributes: ResetStageTasksAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ResetStageTasksRequest = {
    data: ResetStageTasksRequestData;
};
export type UpdateTicketAclResponseAttributes = {
    /** Complete set of ad-hoc permission policies on the ticket after the update. A policy the ticket owns is returned as its `atoms`; a shareable one is returned as its `bundle_id`. Empty when the ticket has none. */
    custom?: CustomPolicy[];
    /** Complete ACL after the update, keyed by permission name (`viewer` for read access, `commenter` for read + comment, `editor` for read + write access). Each value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. */
    acl: {
        [key: string]: AclPrincipal[];
    };
    /** Updated ticket version */
    version: number;
};
export type UpdateTicketAclResponseData = {
    type?: "tickets";
    id: string;
    attributes: UpdateTicketAclResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateTicketAclResponse = {
    data: UpdateTicketAclResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type UpdateTicketAclAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** ACL updates keyed by permission. Valid keys are `viewer` (read access), `commenter` (read + comment), and `editor` (read + write access). Each value is a list of principals with `type` (`user` | `department` | `role` | `implicit`) and `id`. Only permissions present here are replaced; omitted permissions remain unchanged. Send an empty list to clear a permission. Tiered delegation: you may only grant tiers up to your own access (view → viewer; comment → viewer/commenter; edit → any tier); granting a higher tier returns 403. */
    acl?: {
        [key: string]: AclPrincipal[];
    };
    /** Ad-hoc permission policies on this ticket, each granting a specific set of capabilities to specific principals. Unlike `acl`, this is a FULL REPLACEMENT: omit it (or send `null`) to leave the ticket's custom policies unchanged, and send `[]` to remove them all. Each entry states either `atoms` (an ad-hoc policy) or `bundle_id` (a shareable one) — never both. Entries resolving to the same policy have their principals merged. Requires `edit` on the ticket. A policy that omits `ticket_view` grants its capabilities without making the ticket appear in list or search results. */
    custom?: CustomPolicy[] | null;
};
export type UpdateTicketAclRequestData = {
    type: "tickets";
    attributes: UpdateTicketAclAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type UpdateTicketAclRequest = {
    data: UpdateTicketAclRequestData;
};
export type TicketOwnerReassignAttributes = {
    /** Current version for optimistic locking */
    version: VersionInt;
    /** Pilot user ID of the incoming ticket owner. */
    owner_user_id: string;
};
export type TicketOwnerReassignRequestData = {
    type?: "ticket-owner";
    attributes: TicketOwnerReassignAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ReassignTicketOwnerRequest = {
    data: TicketOwnerReassignRequestData;
};
export type ShareExternallyResponseAttributes = {
    /** Number of recipients the email was sent to. */
    recipients_count: number;
    /** Number of documents attached to the email. */
    documents_shared: number;
};
export type ShareExternallyResponseData = {
    type?: "share-externally";
    id: string;
    attributes: ShareExternallyResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ShareExternallyResponse = {
    data: ShareExternallyResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ShareExternallyAttributes = {
    /** Email addresses to share with. Any recipient email that resolves to an active user in this tenant is treated as internal and auto-granted VIEWER access to the ticket; the rest are delivered as external attachments. At least one required. */
    recipients: string[];
    /** IDs of ticket documents to attach. At least one required. */
    document_ids: string[];
    /** Email subject line. Defaults to 'Document shared: {ticket name}'. */
    subject?: string | null;
    /** Optional freeform note from the sender, injected into the email template. */
    message?: string | null;
    /** Current ticket version for optimistic locking on the ACL update. Required only when at least one recipient resolves to an internal user; external-only shares can omit it. A stale version returns 409. */
    version?: VersionInt | null;
};
export type ShareExternallyRequestData = {
    type: "share-externally";
    attributes: ShareExternallyAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ShareExternallyRequest = {
    data: ShareExternallyRequestData;
};
export type ShareInternallyResponseAttributes = {
    /** Number of recipients the email was sent to. */
    recipients_count: number;
    /** Number of documents attached to the email. */
    documents_shared: number;
};
export type ShareInternallyResponseData = {
    type?: "share-internally";
    id: string;
    attributes: ShareInternallyResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ShareInternallyResponse = {
    data: ShareInternallyResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ShareInternallyAttributes = {
    /** Email addresses of internal (existing) recipients. At least one required. */
    recipients: string[];
    /** IDs of ticket documents to attach. At least one required. */
    document_ids: string[];
    /** Email subject line. Defaults to 'Document shared: {ticket name}'. */
    subject?: string | null;
    /** Optional freeform note from the sender, injected into the email template. */
    message?: string | null;
    /** Current ticket version for optimistic locking on the ACL update. */
    version: VersionInt;
};
export type ShareInternallyRequestData = {
    type: "share-internally";
    attributes: ShareInternallyAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ShareInternallyRequest = {
    data: ShareInternallyRequestData;
};
export type RenewalWorkflowAttributes = {
    /** The published intake workflow id to reuse for this renewal. */
    workflow_id: string;
};
export type RenewalWorkflowResponseData = {
    type?: "renewal_workflow";
    id: string;
    attributes: RenewalWorkflowAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type RenewalWorkflowResponse = {
    data: RenewalWorkflowResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type BulkReassignResponseAttributes = {
    /** Total number of task assignments that were updated */
    reassigned_count: number;
    /** IDs of tickets that had at least one task reassigned */
    tickets_affected: string[];
};
export type BulkReassignResponseData = {
    type?: "bulk-operations";
    id: string;
    attributes: BulkReassignResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type BulkReassignResponse = {
    data: BulkReassignResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type BulkReassignAttributes = {
    /** User ID to reassign tasks from */
    from_user_id: string;
    /** User ID to reassign tasks to */
    to_user_id: string;
    /** Optional list of workflow IDs to limit reassignment scope */
    workflow_ids?: string[];
};
export type BulkReassignRequestData = {
    type: "bulk-operations";
    attributes: BulkReassignAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type BulkReassignRequest = {
    data: BulkReassignRequestData;
};
export type SupplierAttributes = {
    /** The Workday ID (WID) of the supplier */
    wid?: string | null;
    /** The name of the supplier */
    name: string;
    /** The Workday supplier status (e.g. Active, Inactive, Hold) */
    external_status?: string | null;
    /** The WSS supplier segmentation (e.g. Approved, Tier 1, Tier 2) */
    segmentation?: string | null;
    /** The WSS supplier risk level (e.g. Low, Medium, High) */
    risk?: string | null;
};
export type SupplierResponseData = {
    type?: "supplier_companies";
    id: string;
    attributes: SupplierAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListSuppliersResponse = {
    data: SupplierResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type ContractTypeAttributes = {
    /** A description of the contract type */
    descriptor: string;
    /** The Workday reference ID of the contract type */
    supplier_contract_type_id: string;
    /** IDs of published workflows already linked to this contract type, taking the latest published version of each workflow. Empty when the contract type is unclaimed. */
    linked_workflow_ids?: string[];
};
export type ContractTypeResponseData = {
    type?: "contract_type";
    id: string;
    attributes: ContractTypeAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListContractTypesResponse = {
    data: ContractTypeResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type IntakeFormWorkflowAttributes = {
    /** Workflow name */
    name: string;
    /** Workflow description shown to end users. */
    description?: string;
    /** Full workflow definition. Included when ?include=workflow_definition is specified. */
    workflow_definition?: WorkflowDefinitionResponse | null;
    /** Current version number (incremented on each update) */
    version: number;
    /** Whether this workflow version is published and available for ticket creation */
    published: boolean;
    /** WSS / Procurement integration type of the workflow (``none`` for plain workflows). */
    integration_type?: IntegrationType;
    /** Workday contract type id; set only for ``procurement`` workflows. */
    contract_type_id?: string | null;
    /** Workday contract type display name; set only for ``procurement`` workflows. */
    contract_type_name?: string | null;
    /** When the workflow was created */
    created_at: string;
    /** When the workflow was last updated */
    updated_at?: string | null;
    /** User ID who created the workflow */
    created_by?: string | null;
    /** User ID who last updated the workflow */
    updated_by?: string | null;
    /** Access control list keyed by permission name. Included when ?include=acl is specified. */
    acl?: {
        [key: string]: AclPrincipal[];
    } | null;
    /** Prepopulated field values (e.g., supplier from WSS). Only present when provided. */
    initial_field_values?: {
        [key: string]: any;
    } | null;
};
export type IntakeFormWorkflowResponseData = {
    type?: "workflows";
    id: string;
    attributes: IntakeFormWorkflowAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type GetIntakeFormLinkResponse = {
    data: IntakeFormWorkflowResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type CompanyAttributes = {
    /** A description of the company or hierarchy */
    descriptor: string;
    /** The Workday ID (WID) of the company or hierarchy */
    id: string;
    /** The Workday reference ID of the organization */
    Organization_Reference_ID: string;
};
export type CompanyResponseData = {
    type?: "company";
    id: string;
    attributes: CompanyAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ListCompaniesResponse = {
    data: CompanyResponseData[];
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type TicketDocumentUploadUrlAttributes = {
    /** Current owner version. Optional and not enforced — document uploads sit outside the owner's optimistic-locking system; accepted for caller compatibility. */
    version?: number | null;
    /** Existing document ID for re-upload of a new version. Omit for a new document. */
    document_id?: string | null;
    /** Filename of the document to upload */
    name: string;
    /** MIME type of the file */
    content_type: string;
    /** File size in bytes */
    content_length: number;
    /** Document's role: contract | attachment | template. Omit to use the owner's default (ATTACHMENT for tickets, TEMPLATE for workflows). */
    document_type?: DocumentType | null;
    /** Optional Unified Field values to set on the document. Each entry identifies a field by UUID and supplies one or more values. */
    fields?: UploadField[] | null;
    /** How to handle a name collision with an existing document. true — rename the incoming file by appending '(N)' before the extension (e.g. 'doc(1).docx'). false — treat this upload as a new version of the existing document with the same name. Omit when document_id is set (re-uploads are already explicitly versioned), or when the caller is certain the name is unique. */
    rename?: boolean | null;
    /** Whether this is the originator's paper (first_party) or the counterparty's paper (third_party). Omit to default to first_party. Applied only on fresh uploads (document_id omitted); ignored on re-uploads, which preserve the existing document's paper_type. */
    paper_type?: PaperType | null;
};
export type TicketDocumentUploadUrlRequestData = {
    type: "documents";
    attributes: TicketDocumentUploadUrlAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TicketDocumentUploadUrlRequest = {
    data: TicketDocumentUploadUrlRequestData;
};
export type DocumentComparisonResponseAttributes = {
    document_id: string;
    newer_version: number;
    older_version: number;
    /** Presigned GET URL for the cached SFDT diff. Null when ``download_status=pending`` (comparison still being generated; poll the same endpoint). */
    download_url?: string | null;
    /** URL expiration time in seconds (0 when pending) */
    expires_in?: number;
    /** ``ready`` when ``download_url`` is set; ``pending`` when the diff is still being generated (HTTP 202; poll the same endpoint). */
    download_status?: DocumentDownloadStatus;
};
export type DocumentComparisonResponseData = {
    type?: "document-comparisons";
    id: string;
    attributes: DocumentComparisonResponseAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type DocumentComparisonResponse = {
    data: DocumentComparisonResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type DocumentLockVersionEntry = {
    /** Document id on the ticket */
    document_id: string;
    /** Per-document optimistic-concurrency token */
    document_lock_version: number;
};
export type TicketVersionAttributes = {
    /** Current optimistic locking version */
    version: number;
    /** Per-document lock versions for optimistic concurrency (Scribyl S2S) */
    documents?: DocumentLockVersionEntry[];
};
export type TicketVersionResponseData = {
    type?: "tickets";
    id: string;
    attributes: TicketVersionAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    links?: Links | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type TicketVersionResponse = {
    data: TicketVersionResponseData;
    included?: {
        [key: string]: any;
    }[] | null;
    meta?: {
        [key: string]: any;
    } | null;
    links?: Links | null;
};
export type DocumentLockRequestAttributes = {
    /** Editor display name; NFC-normalised on validation. */
    reason: string;
    /** Expected ticket version for optimistic locking when acquiring or replacing a lock after expiry. Omit only while renewing an active collaborative lock on this document; the server skips the client version check and persists using the current ticket version. */
    version?: VersionInt | null;
};
export type DocumentLockRequestData = {
    type?: "documents";
    attributes: DocumentLockRequestAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ScribylDocumentLockRequest = {
    data: DocumentLockRequestData;
};
export type DocumentUnlockRequestAttributes = {
    /** Expected ticket version for optimistic locking. Optional when a per-document lock token is supplied; at least one of the two is required to unlock. */
    version?: VersionInt | null;
};
export type DocumentUnlockRequestData = {
    type?: "documents";
    attributes: DocumentUnlockRequestAttributes;
    relationships?: {
        [key: string]: RelationshipData;
    } | null;
    meta?: {
        [key: string]: any;
    } | null;
};
export type ScribylDocumentUnlockRequest = {
    data: DocumentUnlockRequestData;
};
export type WssWorkflowStage = {
    name: string;
    is_enabled: boolean;
};
export type WssContractType = {
    resource_id?: string | null;
    default_value?: string | null;
};
export type WssWorkflowAttributes = {
    parent_id: string;
    name: string;
    modified_date: string;
    paper_type?: string[];
    stages?: WssWorkflowStage[];
    contract_type: WssContractType;
};
export type WssWorkflowResponseData = {
    type?: string;
    id: string;
    attributes: WssWorkflowAttributes;
};
export type WorkflowListResponse = {
    data?: WssWorkflowResponseData[];
};
export type ContractNegotiationUpdateResponseData = {
    type?: string;
    id: string;
};
export type ContractNegotiationUpdateResponse = {
    data: ContractNegotiationUpdateResponseData;
};
